
// 'use client';

// import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
// import styles from '../styles/carenavigator.module.css';
// import CONFIG from '../config/carenavigator.json';
// import { useNavigate } from 'react-router-dom';
// import ConsentScreen from '../components/Reusablecomponents/Consentscreen/Consentscreen';
// import { useAuth } from '../hooks/useAuth';
// import { isMobileVerified, storePatientSession } from '../utils/storage/authStorage';
// import { quickRegister, sendQuickOtp, verifyOtp } from '../api/auth.api';
// import DigitalHealthFAB from '../components/Digitalhealth';
// import { toFtIn } from '../components/Shared/CommonProfileScreen';
// import { HEIGHT_DEFAULT_IN, HEIGHT_MAX_IN, HEIGHT_MIN_IN, WEIGHT_DEFAULT_KG, WEIGHT_MAX_KG, WEIGHT_MIN_KG } from '../config/constants';
// // import { HEIGHT_DEFAULT_IN, HEIGHT_MAX_IN, HEIGHT_MIN_IN, WEIGHT_DEFAULT_KG, WEIGHT_MAX_KG, WEIGHT_MIN_KG } from ;

// const CONSENT_CONFIG = {
//   "pageTitle": "Consent & Privacy",
//   "pageSubtitle": "Before we personalize your care navigator, please review how your information will be used.",
//   "illustrationEmoji": "🛡️",
//   "requiredItems": [
//     { "id": "carePersonalization", "icon": "🤝", "title": "Care Navigator Personalization", "description": "Use my answers to personalize my women's health care navigator.", "type": "checkbox", "required": true },
//     { "id": "clinicAccess", "icon": "👥", "title": "Clinic Care Team Access", "description": "Allow the selected clinic's authorized care team to view my submitted information.", "type": "checkbox", "required": true },
//     { "id": "privacyNotice", "icon": "📋", "title": "Privacy Notice Acknowledgement", "description": "I have read and understand the privacy notice.", "type": "checkbox", "required": true }
//   ],

//   "sideCard": {
//     "title": "Your privacy is our priority",
//     "description": "We collect only what's necessary to provide safe, effective, and personalized care for you.",
//     "items": [
//       { "icon": "🛡️", "title": "Secure & Encrypted", "desc": "Your data is encrypted and stored securely." },
//       { "icon": "🔒", "title": "Private by Design", "desc": "We limit access to your data to authorized care team members only." },
//       { "icon": "👤", "title": "You're in Control", "desc": "You can manage or withdraw optional consent anytime." }
//     ],
//     "infoBubble": "You can manage optional consent later from your profile.",
//     "ctaLabel": "Continue Securely"
//   }
// };
// /* ═══════════════════════════════════════════════════════════════════
//    ICONS
// ═══════════════════════════════════════════════════════════════════ */
// const ArrowRight = ({ size = 16, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
//   </svg>
// );
// const ArrowLeft = ({ size = 16, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
//   </svg>
// );
// const Check = ({ size = 12, color = 'white' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={3} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
//   </svg>
// );
// const Lock = ({ size = 14, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
//   </svg>
// );
// const Star = ({ size = 15, color = '#facc15' }) => (
//   <svg width={size} height={size} fill={color} viewBox="0 0 24 24">
//     <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//   </svg>
// );
// const MapPin = ({ size = 13, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0zM19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
//   </svg>
// );
// const Calendar = ({ size = 14, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
//   </svg>
// );
// const Clock = ({ size = 14, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <circle cx="12" cy="12" r="10" /><path strokeLinecap="round" d="M12 6v6l4 2" />
//   </svg>
// );
// const ChevronDown = ({ size = 12 }) => (
//   <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//   </svg>
// );
// const Verified = ({ size = 13, color = '#16a34a' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
//   </svg>
// );

// /* ═══════════════════════════════════════════════════════════════════
//    HELPERS
// ═══════════════════════════════════════════════════════════════════ */
// const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// function fmt12({ h, m }) {
//   const ampm = h < 12 ? 'AM' : 'PM';
//   const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
//   return `${h12}:${m === 0 ? '00' : '30'} ${ampm}`;
// }

// function buildDateStrip() {
//   const today = new Date(); today.setHours(0, 0, 0, 0);
//   return Array.from({ length: 7 }, (_, i) => { const d = new Date(today); d.setDate(today.getDate() + i); return d; });
// }

// function getAvailableSlots(date) {
//   const now = new Date();
//   const isToday = date.toDateString() === now.toDateString();
//   return CONFIG.appointment.slotHours
//     .filter(s => {
//       if (!isToday) return true;
//       const st = new Date(date); st.setHours(s.h, s.m, 0, 0);
//       return st.getTime() > now.getTime() + 30 * 60 * 1000;
//     })
//     .map(s => s.label || fmt12(s));
// }

// // Map ageGroup + maritalStatus + life-stage answers → journey key
// function classifyJourney(profile, lifeStageAnswers) {
//   const { ageGroup } = profile;
//   const { currentlyPregnant, tryingToConceive, deliveredRecently, periodsStarted, lastPeriod } = lifeStageAnswers;

//   if (deliveredRecently === 'Yes') return 'postpartum';
//   if (currentlyPregnant === 'Yes') return 'pregnancy';
//   if (currentlyPregnant === 'Not sure') return 'earlyPregnancy';
//   if (tryingToConceive === 'Yes') return 'preconception';
//   if (lastPeriod === 'No periods for 12+ months') return 'menopause';

//   if (ageGroup === '65+ years') return 'senior';
//   if (ageGroup === '55–64 years') return 'menopause';
//   if (ageGroup === '46–55 years') return 'perimenopause';
//   if (ageGroup === '36–45 years') return 'perimenopause';
//   if (ageGroup === '10–14 years' || ageGroup === '15–19 years') return 'adolescence';
//   if (tryingToConceive === 'Not sure' && (ageGroup === '26–35 years' || ageGroup === '20–25 years')) return 'reproductive';
//   return 'reproductive';
// }

// // Derive safety check questions for a given route
// function getSafetyQuestions(route) {
//   const byRoute = CONFIG.screens.safetyCheck.byRoute;
//   return byRoute[route] || byRoute.default;
// }

// // Derive adaptive questions for route
// function getAdaptiveQuestions(route) {
//   const byRoute = CONFIG.screens.adaptiveIntake.byRoute;
//   return byRoute[route] || byRoute.default;
// }

// // Derive symptoms for route
// function getSymptomsForRoute(route) {
//   const byRoute = CONFIG.screens.symptoms.byRoute;
//   return byRoute[route] || byRoute.default;
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SHARED COMPONENTS
// ═══════════════════════════════════════════════════════════════════ */
// function ProgressBar({ currentStep, totalSteps, label }) {
//   const pct = totalSteps > 1 ? Math.round((currentStep / (totalSteps - 1)) * 100) : 0;
//   return (
//     <div style={{ marginBottom: 16 }}>
//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
//         <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--fc-purple)' }}>{label}</span>
//         <span style={{ fontSize: 12, color: 'var(--fc-text-muted)' }}>Step {currentStep + 1} of {totalSteps}</span>
//       </div>
//       <div className={styles.progressBar}>
//         <div className={styles.progressFill} style={{ width: `${pct}%` }} />
//       </div>
//     </div>
//   );
// }

// function NavRow({ onBack, onNext, nextLabel = 'Continue', disabled = false, orange = false, footnote }) {
//   return (
//     <div>
//       <div className={styles.navRow}>
//         <button className={styles.btnOutline} onClick={onBack}>
//             Back
//         </button>
//         <button
//           className={`btn-primary ${orange ? styles.btnOrange : ''}`}
//           onClick={onNext}
//           disabled={disabled}
//         >
//           {nextLabel}  
//         </button>
//       </div>
//       {footnote && (
//         <div className={styles.navFootnote}>
//           <Lock size={13} /> {footnote}
//         </div>
//       )}
//     </div>
//   );
// }

// function Checkbox({ checked, onChange }) {
//   return (
//     <div
//       className={`${styles.checkbox} ${checked ? styles.checked : ''}`}
//       onClick={onChange}
//       role="checkbox"
//       aria-checked={checked}
//     >
//       {checked && <Check size={12} />}
//     </div>
//   );
// }

// function Toggle({ checked, onChange }) {
//   return (
//     <label className={styles.toggle}>
//       <input type="checkbox" checked={checked} onChange={onChange} />
//       <div className={styles.toggleTrack} />
//       <div className={styles.toggleThumb} />
//     </label>
//   );
// }

// // Consistent right-side panel used on every screen
// function SidePanel({ title, items, extra }) {
//   return (
//     <div className={styles.sidePanelCard}>
//       {title && <div className={styles.sidePanelTitle}>{title}</div>}
//       {items && (
//         <div className={styles.sidePanelList}>
//           {items.map((item, i) => (
//             <div key={i} className={styles.sidePanelItem}>
//               <div className={styles.sidePanelItemIcon}>{item.icon}</div>
//               <div >
//                 <div className={styles.sidePanelItemTitle}>{item.title}</div>
//                 {item.desc && <div className={styles.sidePanelItemDesc}>{item.desc}</div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//       {extra}
//     </div>
//   );
// }

// // ChipGroup — single select with "Not sure" support
// function ChipGroup({ options, value, onChange, columns = 2 }) {
//   return (
//     <div className={styles.chipGrid} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
//       {options.map(opt => (
//         <button
//           key={opt}
//           className={`${styles.chipCard} ${value === opt ? styles.chipCardActive : ''}`}
//           onClick={() => onChange(opt)}
//           type="button"
//         >
//           {value === opt && <span className={styles.chipCardCheck}><Check size={10} /></span>}
//           {opt}
//         </button>
//       ))}
//     </div>
//   );
// }

// // MultiSelect chips
// function MultiChips({ options, values, onChange }) {
//   const toggle = (opt) => {
//     if (opt === 'None of the above' || opt === 'None') {
//       onChange([opt]);
//     } else {
//       const filtered = values.filter(v => v !== 'None of the above' && v !== 'None');
//       if (filtered.includes(opt)) onChange(filtered.filter(v => v !== opt));
//       else onChange([...filtered, opt]);
//     }
//   };
//   return (
//     <div className={styles.chipGrid} 
//     // style={{ gridTemplateColumns: "1fr, 1fr" }}
//     style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
//     >
//       {options.map(opt => {
//         const active = values.includes(opt);
//         return (
//           // <button
//           //   key={opt}
//           //   className={`${styles.chip} ${styles.chipCard} ${active ? styles.chipCardActive : ''}`}
//           //   onClick={() => toggle(opt)}
//           //   type="button"
//           // >
//           //   {active && <Verified size={12} color="var(--primary-color)" />}
//           //   {opt}
//           // </button>
//           <button
//           key={opt}
//           className={`${styles.chipCard} 
//           ${active? styles.chipCardActive : ''}`}
//           onClick={() => toggle(opt)}
//           type="button"
//         >
//           {active  && <span className={styles.chipCardCheck}><Check size={10} /></span>}
//           {opt}
//         </button>
//         );
//       })}
//     </div>
//   );
// }

// // OTP boxes
// function OtpInput({ length = 6, value, onChange, error }) {
//   const refs = useRef([]);
//   const digits = value.split('');

//   const handleChange = (i, v) => {
//     if (!/^\d?$/.test(v)) return;
//     const arr = digits.slice(0, length); arr[i] = v;
//     while (arr.length < length) arr.push('');
//     onChange(arr.join(''));
//     if (v && i < length - 1) refs.current[i + 1]?.focus();
//   };
//   const handleKey = (i, e) => {
//     if (e.key === 'Backspace' && !digits[i] && i > 0) refs.current[i - 1]?.focus();
//   };

//   return (
//     <div>
//       <div className={styles.otpRow}>
//         {Array.from({ length }).map((_, i) => (
//           <input
//             key={i}
//             ref={el => refs.current[i] = el}
//             className={`${styles.otpBox} ${digits[i] ? styles.filled : ''}`}
//             type="tel"
//             maxLength={1}
//             value={digits[i] || ''}
//             onChange={e => handleChange(i, e.target.value)}
//             onKeyDown={e => handleKey(i, e)}
//           />
//         ))}
//       </div>
//       {error && <div className={styles.errorText}>{error}</div>}
//     </div>
//   );
// }

// // Countdown resend
// function ResendCountdown({ onResend }) {
//   const [sec, setSec] = useState(60);
//   useEffect(() => {
//     if (sec <= 0) return;
//     const t = setTimeout(() => setSec(s => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [sec]);
//   return (
//     <div style={{ fontSize: 12, color: 'var(--fc-text-muted)', textAlign: 'center', marginTop: 8 }}>
//       Didn't receive it?{' '}
//       {sec > 0
//         ? <span>Resend in <strong style={{ color: 'var(--fc-purple)' }}>{sec}s</strong></span>
//         : <span style={{ color: 'var(--fc-purple)', fontWeight: 600, cursor: 'pointer' }} onClick={() => { setSec(60); onResend?.(); }}>Resend OTP</span>
//       }
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 0 — WELCOME
// ═══════════════════════════════════════════════════════════════════ */
// function WelcomeScreen({ onStart }) {
//   const W = CONFIG.screens.welcome;
//   const A = CONFIG.app;
//   return (
//     <div style={{ textAlign: 'center' }}>
//       <div className={styles.welcomeHeader}>
//         <a href={A.homeUrl} className={styles.welcomeLogoLink} rel="noopener noreferrer">
//           <img src={A.logoSrc} alt={A.logoAlt} style={{ height: 36, width: 'auto', display: 'block' }} />
//         </a>
//         <a href="/lifeStages/" className={styles.welcomeBack}>Back</a>
//       </div>
//       <div className={styles.welcomeHero}>
//         <h2 className={styles.welcomeTitle}>{W.title}</h2>
//         <p className={styles.welcomeSubtitle}>{W.subtitle}</p>
//         <img src={W.imageSrc} alt={W.imageAlt} className={styles.welcomeImage} onError={e => { e.target.style.display = 'none'; }} />
//       </div>
//       <div className={styles.welcomeChecklist}>
//         {W.checklist.map(text => (
//           <div key={text} className={styles.welcomeCheckItem}>
//             <div className={styles.welcomeCheckDot}><Star size={12} color="var(--primary-color)" /></div>
//             <span className={styles.welcomeCheckText}>{text}</span>
//           </div>
//         ))}
//       </div>
//       <div className={styles.welcomeCtaWrap}>
//         <button className={`btn-primary`} onClick={onStart}>
//           {W.ctaLabel}
//         </button>
//       </div>
//     </div>
//   );
// }



// function IdentifyPatientScreen({ onNext, onBack, setProfile, identifyState, setIdentifyState, }) {
//   const IP = CONFIG.screens.identifyPatient;
//   const navigate = useNavigate();
//   const {
//     patientType,
//     mobile,
//     fullName,
//     otp,
//     otpSent,
//     otpVerified,
//     dob,
//     ageGroup,
//     marital,
//     occupation,
//     height,
//     weight,
//     profileSubStep,
//     errors,
//     showLogin
//   } = identifyState;

//   const { user } = useAuth();

//   const updateIdentifyState = (data) => {
//     setIdentifyState(prev => ({
//       ...prev,
//       ...data,
//     }));
//   };
//   const updateErrors = (
//     data
//   ) => {

//     setIdentifyState(prev => ({
//       ...prev,
//       errors: data,
//     }));
//   };


//   const isVerified = isMobileVerified(mobile || user?.mobile || '');
//   const inProfileFlow = profileSubStep > 0;

//   const isNew = patientType === 'new';
//   const ntab = IP.tabs.new;
//   const etab = IP.tabs.existing;

//   // const bmi = height > 0 ? +(weight / ((height / 100) ** 2)).toFixed(1) : 0;
//   // ✅ Convert inches → meters (× 0.0254)
// const bmi = height > 0 ? +(weight / ((height * 0.0254) ** 2)).toFixed(1) : 0;
//   const bmiCategory =
//     bmi < 18.5 ? { label: 'Underweight', color: '#3b82f6', bg: '#eff6ff' }
//       : bmi < 25 ? { label: 'Normal weight', color: '#16a34a', bg: '#f0fdf4' }
//         : bmi < 30 ? { label: 'Overweight', color: '#d97706', bg: '#fffbeb' }
//           : { label: 'Obese', color: '#dc2626', bg: '#fef2f2' };

//   useEffect(() => {

//     if (!user) return;

//     updateIdentifyState({

//       fullName:
//         fullName ||
//         user?.fullName ||
//         '',

//       mobile:
//         mobile ||
//         user?.mobile ||
//         '',

//       dob:
//         dob ||
//         user?.dob ||
//         '',

//       ageGroup:
//         ageGroup ||
//         user?.ageGroup ||
//         '',

//       marital:
//         marital ||
//         user?.maritalStatus ||
//         '',

//       occupation: occupation || user?.occupation || '',
//       height: height || user?.height || HEIGHT_DEFAULT_IN,
//       weight: weight || user?.weightKg || WEIGHT_DEFAULT_KG,
//     });

//   }, [user]);

//   const updateIdentify =
//     (data) => {

//       setIdentifyState(
//         prev => ({
//           ...prev,
//           ...data,
//         })
//       );
//     };

//   const firstIncompleteStep = () => {
//     if (!ageGroup) return 1;
//     if (!marital) return 2;
//     if (!occupation) return 3;
//     return 4;
//   };


//   const handleSendOtp =
//     async () => {
//       const errs = {};
//       if (
//         isNew &&
//         !fullName.trim()
//       ) {

//         errs.fullName =
//           'Full name is required';
//       }

//       if (
//         !/^\d{10}$/.test(
//           mobile
//         )
//       ) {

//         errs.mobile =
//           'Enter a valid 10-digit number';
//       }
//       if (!/^[6-9]\d{9}$/.test(mobile.trim())) {
//         errs.mobile =
//           'Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9';
//       }
//       if (
//         Object.keys(errs)
//           .length
//       ) {

//         updateErrors(errs);

//         return;
//       }

//       updateErrors({});
//       if (isVerified) {

//         updateIdentifyState({

//           otpVerified: true,

//           profileSubStep: 1
//         });

//         return;
//       }

//       try {

//         const res =
//           await sendQuickOtp({

//             fullName:
//               fullName.trim(),

//             mobileNumber:
//               mobile.trim(),
//           });
//         console.log(res, "this is the resssssssssss")

//         if (res.success) {
//           updateIdentifyState({ otpSent: true, });
//         }
//         else {
//           updateErrors({
//             mobile:
//               res.message ||
//               'Failed to send OTP',
//           });
//         }

//         // } catch (err) {

//         //   updateErrors({

//         //     mobile:
//         //       err.message ||
//         //       'Failed to send OTP',
//         //   });
//         // }
//       } catch (err) {
//         if (err?.message?.toLowerCase().includes('already registered') ||
//           err?.message?.toLowerCase().includes('please login')) {
//           updateIdentifyState({ showLogin: true });
//           updateErrors({ mobile: err.message });
//         } else {
//           updateErrors({ mobile: err.message || 'Failed to send OTP' });
//         }
//       }
//     };
//   const handleVerifyOtp =
//     async () => {

//       if (
//         otp.length < 6
//       ) {

//         updateErrors({

//           otp:
//             'Enter all 6 digits',
//         });

//         return;
//       }

//       updateErrors({});

//       try {
//         await verifyOtp({

//           fullName,

//           mobileNumber:
//             mobile,

//           otp,
//         });
//         const registerResponse =
//           await quickRegister({

//             fullName,

//             mobileNumber:
//               mobile,

//             dob,

//             otp,

//             orgName:
//               `Mukta Women's Clinic`,
//           });
//         storePatientSession({

//           ...registerResponse.data,

//           fullName,

//           mobile,

//           dob,

//           isVerified:
//             true,
//         });
//         updateIdentifyState({

//           otpVerified:
//             true,

//           otpSent:
//             true,

//           profileSubStep:
//             firstIncompleteStep(),
//         });

//       } catch (err) {

//         updateErrors({

//           otp:
//             err.message ||
//             'Verification failed',
//         });
//       }
//     };


//   const handleProfileNext =
//     () => {
//       if (
//         profileSubStep === 1
//       ) {

//         if (!ageGroup) {

//           updateErrors({

//             ageGroup:
//               'Please select your age group',
//           });

//           return;
//         }

//         storePatientSession({
//           ageGroup,
//         });

//         updateErrors({});

//         updateIdentifyState({
//           profileSubStep: 2,
//         });

//         return;
//       }
//       if (
//         profileSubStep === 2
//       ) {

//         if (!marital) {

//           updateErrors({

//             marital:
//               'Please select marital status',
//           });

//           return;
//         }

//         storePatientSession({

//           maritalStatus:
//             marital,
//         });

//         updateErrors({});

//         updateIdentifyState({
//           profileSubStep: 3,
//         });

//         return;
//       }

//       if (
//         profileSubStep === 3
//       ) {

//         if (!occupation) {

//           updateErrors({

//             occupation:
//               'Please select occupation',
//           });

//           return;
//         }

//         storePatientSession({
//           occupation,
//         });

//         updateErrors({});

//         updateIdentifyState({
//           profileSubStep: 4,
//         });

//         return;
//       }

//       if (
//         profileSubStep === 4
//       ) {

//         storePatientSession({

//           height,
//           weight,
//         });

//         setProfile({

//           fullName,
//           mobile,

//           ageGroup,

//           maritalStatus:
//             marital,

//           occupation,

//           height,
//           weight,
//         });

//         onNext();
//       }
//     };

//   const handleProfileBack =
//     () => {
//       updateErrors({});
//       if (
//         profileSubStep === 1
//       ) {
//         updateIdentifyState({
//           profileSubStep: 0,
//           otpSent:
//             isVerified
//               ? false
//               : true,
//         });
//         return;
//       }
//       updateIdentifyState({
//         profileSubStep:
//           profileSubStep - 1,
//       });
//     };

//   // ─── Side-panel extras (unchanged) ────────────────────────────────
//   const existingBenefits = IP.existingBenefits;
//   const sideItems = isNew
//     ? [
//       { icon: '👤', title: 'Create your profile', desc: 'Get personalised care tailored to your needs.' },
//       { icon: '📁', title: 'Save your records', desc: 'Access reports and appointments anytime.' },
//       { icon: '🔒', title: 'Secure & private', desc: 'Your data is encrypted end-to-end.' },
//     ]
//     : existingBenefits.items;

//   const profileSubStepExtra =
//     profileSubStep === 4 ? (
//       <div style={{ marginTop: 12 }}>
//         <div style={{ background: bmiCategory.bg, border: `1.5px solid ${bmiCategory.color}`, borderRadius: 12, padding: '14px 16px', marginBottom: 10 }}>
//           <div style={{ fontSize: 11, fontWeight: 600, color: bmiCategory.color, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Live BMI</div>
//           <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4 }}>
//             <span style={{ fontSize: 32, fontWeight: 800, color: bmiCategory.color, lineHeight: 1 }}>{bmi}</span>
//             <span style={{ fontSize: 13, color: bmiCategory.color, fontWeight: 600 }}>{bmiCategory.label}</span>
//           </div>
//           <div style={{ position: 'relative', height: 8, borderRadius: 4, background: 'linear-gradient(to right, #3b82f6 0%, #16a34a 30%, #d97706 60%, #dc2626 100%)', marginTop: 8, marginBottom: 6 }}>
//             <div style={{
//               position: 'absolute', top: '50%', transform: 'translate(-50%, -50%)',
//               left: `${Math.min(Math.max(((bmi - 15) / (40 - 15)) * 100, 0), 100)}%`,
//               width: 14, height: 14, borderRadius: '50%', background: '#fff',
//               border: `2.5px solid ${bmiCategory.color}`, boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
//             }} />
//           </div>
//           <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#9ca3af' }}>
//             <span>15</span><span>18.5</span><span>25</span><span>30</span><span>40</span>
//           </div>
//         </div>
//       </div>
//     )
//       : profileSubStep === 3
//         ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>💼</span><span className={styles.consentInfoBubbleText}>Your occupation helps us recommend care that fits your lifestyle and schedule.</span></div>
//         : profileSubStep === 2
//           ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>💍</span><span className={styles.consentInfoBubbleText}>Marital status helps us understand your life stage and personalise your care journey.</span></div>
//           : profileSubStep === 1
//             ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>🎂</span><span className={styles.consentInfoBubbleText}>Age helps us show you the most relevant health topics and care options.</span></div>
//             : null;

//   // ─── Render (unchanged structure) ─────────────────────────────────
//   return (
//     <div>
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{IP.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{IP.pageSubtitle}</p>
//         </div>
//         {/* <div className={styles.screenHeaderIllustration}>
//           <div style={{ fontSize: 72, textAlign: 'center' }}>👩‍💻</div>
//         </div> */}
//          <img src='/images/profile.svg' className='h-20 w-20'/>
//       </div>

//       <div className={styles.twoCol}>
//         <div>

//           {/* ── PROFILE SUB-STEPS ── */}
//           {inProfileFlow ? (
//             <div className={styles.sectionBox}>
//               <div className={styles.sectionBoxLabel}>
//                 Complete your profile · Question {profileSubStep} of 4
//               </div>

//               {profileSubStep === 1 && (
//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>What's your age group?</label>
//                   <ChipGroup
//                     options={ntab.ageGroupOptions}
//                     value={ageGroup}
//                     onChange={v => updateIdentify({
//                       ageGroup: v
//                     })}
//                     columns={3}
//                   />
//                   {errors.ageGroup && <div className={styles.errorText}>{errors.ageGroup}</div>}
//                 </div>
//               )}

//               {profileSubStep === 2 && (
//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>What's your marital status?</label>
//                   <ChipGroup
//                     options={ntab.maritalOptions}
//                     value={marital}
//                     onChange={v => updateIdentify({
//                       marital: v
//                     })}
//                     columns={3}
//                   />
//                   {errors.marital && <div className={styles.errorText}>{errors.marital}</div>}
//                 </div>
//               )}

//               {profileSubStep === 3 && (
//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Nice 👍 What best describes your occupation?</label>
//                   <ChipGroup
//                     options={ntab.occupationOptions}
//                     value={occupation}
//                     onChange={v => updateIdentify({
//                       occupation: v
//                     })}
//                     columns={3}
//                   />
//                   {errors.occupation && <div className={styles.errorText}>{errors.occupation}</div>}
//                 </div>
//               )}

//               {profileSubStep === 4 && (
//                 <>
//                   <div className={styles.formGroup}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
//                       <label className={styles.label} style={{ margin: 0 }}>What's your height?</label>
//                       <span className={styles.sliderValue}>{toFtIn(height)} </span>
//                     </div>
//                     <input
//                       className={styles.rangeSlider}
//                       type="range"

//                       // min={ntab.heightMin} max={ntab.heightMax} 
//                       min={toFtIn(HEIGHT_MIN_IN)}
//                       max={toFtIn(HEIGHT_MAX_IN)}

//                       step={1}
//                       value={toFtIn(height)}
//                       onChange={e => updateIdentifyState({
//                         height:
//                           Number(
//                             e.target.value
//                           ),
//                       })}
//                     />
//                     <div className={styles.rangeLabels}><span>
//                       {toFtIn(ntab.heightMin)} 
//                       </span><span>
//                         {toFtIn(ntab.heightMax)}
//                          </span></div>
//                   </div>

//                   <div className={styles.formGroup}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
//                       <label className={styles.label} style={{ margin: 0 }}>What's your weight?</label>
//                       <span className={styles.sliderValue}>{weight} kg</span>
//                     </div>
//                     <input
//                       className={styles.rangeSlider}
//                       type="range"
//                       min={WEIGHT_MIN_KG} max={WEIGHT_MAX_KG} step={1}
//                       value={weight}
//                       onChange={e => updateIdentifyState({
//                         weight: Number(e.target.value)
//                       })}
//                     />
//                     <div className={styles.rangeLabels}><span>{WEIGHT_MIN_KG} kg</span><span>{WEIGHT_MAX_KG} kg</span></div>
//                   </div>
//                 </>
//               )}
//             </div>

//           ) : (
//             /* ── OTP / MOBILE FORM ── */
//             <div className={styles.sectionBox}>
//               <div className={styles.sectionBoxLabel}>Find or create your profile</div>

//               {isNew && !otpSent && (
//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>{ntab.fullNameLabel}</label>
//                   <input
//                     className={`${styles.input} ${errors.fullName ? styles.error : ''}`}
//                     type="text"
//                     placeholder={ntab.fullNamePlaceholder}
//                     value={fullName}
//                     onChange={e => updateIdentify({
//                       fullName: e.target.value
//                     })}
//                   />
//                   {errors.fullName && <div className={styles.errorText}>{errors.fullName}</div>}
//                 </div>
//               )}

//               {!otpSent && (
//                 <>
//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Mobile Number</label>
//                     {!isNew &&
//                     <span className={styles.hint}>We'll send a one-time password (OTP) to verify your number</span>
//                     }
//                     <div className={`${styles.phoneWrap} ${errors.mobile ? styles.error : ''}`} style={{ marginTop: 6 }}>
//                       <div className={styles.phoneCode}>🇮🇳 +91</div>
//                       <input
//                         className={styles.phoneInput}
//                         type="tel"
//                         placeholder="Enter 10-digit mobile number"
//                         maxLength={10}
//                         value={mobile}
//                         onChange={e => updateIdentify({
//                           mobile: e.target.value.replace(/\D/g, '')
//                         })}
//                       />
//                     </div>
//                     {/* {errors.mobile && <div className={styles.errorText}>{errors.mobile}</div>} */}
//                     {errors.mobile && <div className={`${styles.errorText} flex justify-between items-center`}
//                     >{errors.mobile}

//                       {showLogin && (
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                           {/* <button
//                           className={`btn-primary `}
//                           onClick={() => {
//                             updateIdentifyState({ patientType: 'existing', showLogin: false });
//                             updateErrors({});
//                           }}
//                         >
//                           Login instead
//                         </button> */}
//                           <button
//                             type="button"
//                             className="ava-text-caption   hover:underline bg-transparent border-none p-0 cursor-pointer animate-bounce"
//                             onClick={() => {
//                               // updateIdentifyState({ patientType: 'existing', showLogin: false });
//                               // updateErrors({});
//                               navigate('/sign-in')
//                             }}
//                             style={{ color: "var(--primary-color)" }}
//                           >
//                             Login instead
//                           </button>
//                         </div>
//                       )}
//                     </div>}


//                   </div>
//                   {/* <button className={`btn-primary ${styles.btnPrimary}`} onClick={handleSendOtp}>
//                     {isVerified ? ntab.continueLabel : isNew ? ntab.sendOtpLabel :  etab.sendOtpLabel}  
//                   </button> */}
//                   {!isNew && (
//                     <div className={styles.securityBox} style={{ marginTop: 12 }}>
//                       <span className={styles.securityBoxIcon}>🔒</span>
//                       <span className={styles.securityBoxText}>{etab.securityNote}</span>
//                     </div>
//                   )}
//                   <div className={styles.navRow} style={{ marginTop: 16 }}>
//                     <button className={styles.btnOutline} onClick={onBack}>
//                        Back
//                     </button>
//                     <button className={`btn-primary`} onClick={handleSendOtp}>
//                       {isVerified ? ntab.continueLabel : isNew ? ntab.sendOtpLabel : etab.sendOtpLabel}  
//                     </button>
//                   </div>
//                 </>
//               )}

//               {otpSent && (
//                 <div>
//                   <div style={{ fontSize: 13, color: 'var(--fc-text-muted)', marginBottom: 12, textAlign: 'center' }}>
//                     OTP sent to <strong style={{ color: 'var(--fc-purple)' }}>+91 {mobile}</strong>
//                     <button
//                       style={{ background: 'none', border: 'none', color: 'var(--fc-purple)', fontSize: 12, cursor: 'pointer', marginLeft: 8 }}
//                       // onClick={() => { setOtpSent(false); setOtp(''); setErrors({}); }}
//                       onClick={() => updateIdentifyState({
//                         otpSent: false,
//                         otp: '',
//                       })}
//                     >
//                       Change
//                     </button>
//                   </div>
//                   <label className={styles.label} style={{ textAlign: 'center', display: 'block', marginBottom: 8 }}>Enter OTP</label>
//                   <OtpInput length={6} value={otp} onChange={value =>
//                     updateIdentifyState({
//                       otp: value,
//                     })
//                   }
//                     error={
//                       errors.otp
//                     } />
//                   <ResendCountdown />
//                   <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     {/* <button className={`btn-primary ${styles.btnPrimary}`} onClick={handleVerifyOtp}>
//                       {isNew ? 'Verify & Continue' : 'Verify & Go to Dashboard'}  
//                     </button> */}
//                   </div>
//                   {!isNew && (
//                     <div style={{ fontSize: 11, color: 'var(--fc-text-muted)', textAlign: 'center', marginTop: 8 }}>
//                       You'll be redirected to your patient dashboard after verification.
//                     </div>
//                   )}
//                   <div className={styles.navRow} style={{ marginTop: 16 }}>
//                     <button className={styles.btnOutline} onClick={() => updateIdentifyState({
//                       otpSent: false,
//                       otp: '',
//                     })}>
//                         Back
//                     </button>
//                      <button className={`btn-primary `} onClick={handleVerifyOtp}>
//                       {isNew ? 'Verify & Continue' : 'Verify & Go to Dashboard'}  
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* Right panel */}
//         <div className={styles.sideCol}>
//           <SidePanel
//             title={isNew ? 'New Patient Benefits' : existingBenefits.title}
//             items={sideItems}
//             extra={profileSubStepExtra}
//           />
//         </div>

//         {/* Per-step Back / Next */}
//         {inProfileFlow && (
//           <div className={styles.navRow} style={{ marginTop: 8 }}>
//             <button className={styles.btnOutline} onClick={handleProfileBack}>
//                 Back
//             </button>
//             <button className={`btn-primary `} onClick={handleProfileNext}>
//               {profileSubStep === 4 ? 'Continue' : 'Next'}  
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 3 — LIFE STAGE QUESTIONS
//    Driven by ageGroup + marital status from profile
// ═══════════════════════════════════════════════════════════════════ */
// function LifeStageScreen({ profile, lifeStageAnswers, setLifeStageAnswers, onNext, onBack, currentStep, totalSteps }) {
//   const LS = CONFIG.screens.lifeStage;
//   const today = new Date().toISOString().split("T")[0];
//   const [answers, setAnswers] = useState(lifeStageAnswers || {});

//   // Filter questions based on ageGroup
//   const filteredQuestions = useMemo(() => {
//     return LS.questions.filter(q => {
//       if (q.showForAgeGroups && !q.showForAgeGroups.includes(profile.ageGroup)) return false;
//       if (q.showIf) {
//         return Object.entries(q.showIf).every(([key, vals]) => vals.includes(answers[key]));
//       }
//       return true;
//     });
//   }, [LS.questions, profile.ageGroup, answers]);

//   const setAnswer = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));

//   const allAnswered = filteredQuestions.every(q => {
//     if (q.type === 'dateOrSelect') return answers[q.id] != null;
//     return !!answers[q.id];
//   });

//   const handleNext = () => {
//     setLifeStageAnswers(answers);
//     onNext();
//   };

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Life Stage" />
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{LS.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{LS.pageSubtitle}</p>
//         </div>
//         <div className={styles.screenHeaderIllustration}>
//           <div style={{ fontSize: 60, textAlign: 'center' }}>🩺</div>
//         </div>
//       </div>

//       <div className={styles.twoCol}>
//         <div>
//           {filteredQuestions.map((q, idx) => (
//             <div key={q.id} className={styles.formGroup}>
//               <label className={styles.label}>
//                 <span style={{ color: 'var(--fc-purple)', marginRight: 6, fontWeight: 700 }}>{idx + 1}.</span>
//                 {q.text}
//               </label>
//               {q.type === 'dateOrSelect' ? (
//                 <div>
//                   <input
//                     className={styles.input}
//                     type="date"
//                     max={today}
//                     value={answers[q.id] && !q.alternateOptions?.includes(answers[q.id]) ? answers[q.id] : ''}
//                     onChange={e => setAnswer(q.id, e.target.value)}
//                     style={{ marginBottom: 8 }}
//                   />
//                   <div className={styles.chipRow} style={{ flexWrap: 'wrap', gap: 8 }}>
//                     {q.alternateOptions.map(opt => (
//                       <button
//                         key={opt}
//                         className={`${styles.chip} ${answers[q.id] === opt ? styles.chipActive : ''}`}
//                         onClick={() => setAnswer(q.id, opt)}
//                         type="button"
//                       >{opt}</button>
//                     ))}
//                   </div>
//                 </div>
//               ) : (
//                 <ChipGroup
//                   options={q.options}
//                   value={answers[q.id] || ''}
//                   onChange={val => setAnswer(q.id, val)}
//                   columns={q.options.length <= 3 ? q.options.length : 3}
//                 />
//               )}
//             </div>
//           ))}
//         </div>

//         <div className={styles.sideCol}>
//           {/* <SidePanel title={LS.sideCard.title} items={LS.sideCard.items} /> */}

//           {/* Profile summary card */}
//           <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
//             <div className={styles.sidePanelTitle}>Your Profile</div>
//             {[
//               { label: 'Name', val: profile.fullName },
//               { label: 'Age Group', val: profile.ageGroup },
//               { label: 'Marital Status', val: profile.maritalStatus },
//               { label: 'Occupation', val: profile.occupation },
//               { label: 'Height', val: `${toFtIn(profile.height)} ` },
//               { label: 'Weight', val: `${profile.weight} kg` },
//             ].map(({ label, val }) => (
//               <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--fc-border)' }}>
//                 <span style={{ color: 'var(--fc-text-muted)' }}>{label}</span>
//                 <span style={{ fontWeight: 600, color: 'var(--fc-text)' }}>{val || '—'}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <NavRow onBack={onBack} onNext={handleNext} disabled={!allAnswered} footnote="Your answers are private and encrypted." />
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 4 — ENTRY REASON
//    Auto-suggests ONE journey from life-stage; shows that journey's options
//    Patient selects one or multiple options → each has a route
// ═══════════════════════════════════════════════════════════════════ */
// function EntryReasonScreen({ profile, lifeStageAnswers, selectedOptions, setSelectedOptions, setActiveRoute, onNext, onBack, currentStep, totalSteps }) {
//   const ER = CONFIG.screens.entryReason;

//   // Classify journey
//   const journeyKey = useMemo(() => classifyJourney(profile, lifeStageAnswers), [profile, lifeStageAnswers]);
//   const journey = ER.journeys[journeyKey];

//   const toggle = (optId) => {
//     setSelectedOptions(prev =>
//       prev.includes(optId) ? prev.filter(id => id !== optId) : [...prev, optId]
//     );
//   };

//   const handleNext = () => {
//     // Determine primary route from first selected option
//     const firstOpt = journey.options.find(o => selectedOptions.includes(o.id));
//     if (firstOpt) setActiveRoute(firstOpt.route);
//     onNext();
//   };

//   if (!journey) return null;

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Entry Reason" />
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{ER.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{ER.pageSubtitle}</p>
//         </div>
//       </div>

//       <div className={styles.twoCol}>
//         <div>
//           {/* Auto-suggested journey badge */}
//           <div className={styles.journeyBadgeWrap}>
//             <div className={styles.journeyBadge} style={{ borderColor: journey.color, color: journey.color }}>
//               <span style={{ fontSize: 18 }}>{journey.icon}</span>
//               <div>
//                 <div style={{ fontWeight: 700, fontSize: 14 }}>{journey.label}</div>
//                 <div style={{ fontSize: 11, opacity: 0.8 }}>{journey.ageRange}</div>
//               </div>
//               <div className={styles.journeyBadgeSuggest}>
//                 <Verified size={13} color={journey.color} /> {ER.autoSuggestNote}
//               </div>
//             </div>
//           </div>

//           <div style={{ fontSize: 13, color: 'var(--fc-text-muted)', marginBottom: 14, marginTop: 4 }}>
//             Select one or more options that best match your concern today:
//           </div>

//           {/* Options */}
//           <div className={styles.entryReasonGrid}>
//             {journey.options.map(opt => {
//               const sel = selectedOptions.includes(opt.id);
//               return (
//                 <div
//                   key={opt.id}
//                   className={`${styles.entryReasonCard} ${sel ? styles.selected : ''} ${opt.urgent ? styles.urgentCard : ''}`}
//                   onClick={() => toggle(opt.id)}
//                 >
//                   {sel && <div className={styles.entryReasonCheck}><Check size={10} /></div>}
//                   {opt.urgent && <div className={styles.urgentBadge}>🚨 Urgent</div>}
//                   <div className={styles.entryReasonIcon}>{opt.icon}</div>
//                   <div className={styles.entryReasonLabel}>{opt.label}</div>
//                   <div className={styles.entryReasonDesc}>{opt.desc}</div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         <div className={styles.sideCol}>
//           <div className={styles.sidePanelCard} style={{ marginBottom: 12 }}>
//             <div className={styles.sidePanelTitle}>Your Profile</div>
//             {[
//               { label: 'Name', val: profile.fullName },
//               { label: 'Age Group', val: profile.ageGroup },
//               { label: 'Marital Status', val: profile.maritalStatus },
//               { label: 'Occupation', val: profile.occupation },
//               { label: 'Height', val: `${toFtIn(profile.height)}` },
//               { label: 'Weight', val: `${profile.weight} kg` },
//             ].map(({ label, val }) => (
//               <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--fc-border)' }}>
//                 <span style={{ color: 'var(--fc-text-muted)' }}>{label}</span>
//                 <span style={{ fontWeight: 600, color: 'var(--fc-text)' }}>{val || '—'}</span>
//               </div>
//             ))}
//           </div>
//           <SidePanel
//             title="Your matched journey"
//             items={[
//               // { icon: journey.icon, title: journey.label, desc: `Age range: ${journey.ageRange}` },
//               // { icon: '🎯', title: 'Based on your answers', desc: 'We matched this journey from your life-stage responses.' },
//               { icon: '🔄', title: 'You can select multiple', desc: 'Choose all concerns that apply to you today.' },
//             ]}
//             extra={
//               selectedOptions.length > 0 && (
//                 <div style={{ marginTop: 12 }}>
//                   <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--fc-purple)', marginBottom: 6 }}>Selected ({selectedOptions.length})</div>
//                   {selectedOptions.map(id => {
//                     const opt = journey.options.find(o => o.id === id);
//                     return opt ? (
//                       <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--fc-text)', marginBottom: 4 }}>
//                         <span>{opt.icon}</span> {opt.label}
//                       </div>
//                     ) : null;
//                   })}
//                 </div>
//               )
//             }
//           />
//         </div>
//       </div>

//       <NavRow onBack={onBack} onNext={handleNext} disabled={selectedOptions.length === 0} />
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 5 — SYMPTOMS
//    Based on activeRoute from entry reason
// ═══════════════════════════════════════════════════════════════════ */
// function SymptomsScreen({ activeRoute, selectedSymptoms, setSelectedSymptoms, symptomDuration, setSymptomDuration, symptomSeverity, setSymptomSeverity, onNext, onBack, currentStep, totalSteps }) {
//   const S = CONFIG.screens.symptoms;
//   const options = getSymptomsForRoute(activeRoute);

//   const toggle = (sym) => {
//     setSelectedSymptoms(prev => prev.includes(sym) ? prev.filter(s => s !== sym) : [...prev, sym]);
//   };

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Symptoms" />
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{S.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{S.pageSubtitle}</p>
//         </div>
//         <div className={styles.screenHeaderIllustration}>
//           <div style={{ fontSize: 56, textAlign: 'center' }}>🩺</div>
//         </div>
//       </div>

//       <div className={styles.twoCol}>
//         <div>
//           {/* Symptoms multi-select */}
//           <div className={styles.formGroup}>
//             <label className={styles.label}>What symptoms are you experiencing?</label>
//             <div className={styles.symptomsGrid}>
//               {options.map(sym => {
//                 const sel = selectedSymptoms.includes(sym);
//                 return (
//                   <div
//                     key={sym}
//                     className={`${styles.symptomCard} ${sel ? styles.selected : ''}`}
//                     onClick={() => toggle(sym)}
//                   >
//                     {sel && <div className={styles.symptomCardCheck}><Check size={10} /></div>}
//                     <span className={styles.symptomCardLabel}>{sym}</span>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Duration */}
//           <div className={styles.formGroup}>
//             <label className={styles.label}>How long have you had these symptoms?</label>
//             <div className={styles.chipRow} style={{ flexWrap: 'wrap', gap: 8 }}>
//               {S.durationOptions.map(d => (
//                 <button
//                   key={d}
//                   className={`${styles.chip} ${symptomDuration === d ? styles.chipActive : ''}`}
//                   onClick={() => setSymptomDuration(d)}
//                   type="button"
//                 >{d}</button>
//               ))}
//             </div>
//           </div>

//           {/* Severity */}
//           <div className={styles.formGroup}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
//               <label className={styles.label} style={{ margin: 0 }}>Severity</label>
//               <div style={{ display: 'flex', gap: 8 }}>
//                 {S.severityOptions.map(sv => (
//                   <button
//                     key={sv.value}
//                     onClick={() => setSymptomSeverity(sv.value)}
//                     style={{
//                       padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer',
//                       border: `1.5px solid ${sv.color}`,
//                       background: symptomSeverity === sv.value ? sv.color : 'transparent',
//                       color: symptomSeverity === sv.value ? '#fff' : sv.color,
//                     }}
//                   >{sv.label}</button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className={styles.sideCol}>
//           <SidePanel title={S.sideCard.title} items={S.sideCard.items} />

//           {selectedSymptoms.length > 0 && (
//             <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
//               <div className={styles.sidePanelTitle}>Selected symptoms ({selectedSymptoms.length})</div>
//               {selectedSymptoms.map(s => (
//                 <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, padding: '3px 0' }}>
//                   <span style={{ color: '#16a34a' }}>✓</span> {s}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       <NavRow onBack={onBack} onNext={onNext} disabled={selectedSymptoms.length === 0} />
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 6 — SAFETY CHECK
//    Max 3 questions per route. Last option always "None of above / Not sure"
// ═══════════════════════════════════════════════════════════════════ */
// function SafetyCheckScreen({ activeRoute, safetyAnswers, setSafetyAnswers, onNext, onEmergency, onBack, currentStep, totalSteps }) {
//   const SC = CONFIG.screens.safetyCheck;
//   const allQuestions = getSafetyQuestions(activeRoute);
//   // Cap at 3 questions (the "none" option is mandatory last)
//   const noneQ = allQuestions.find(q => q.isNone);
//   const urgentQs = allQuestions.filter(q => !q.isNone).slice(0, 2); // max 2 urgent + 1 none = 3
//   const questions = noneQ ? [noneQ,...urgentQs ] : urgentQs;

//   const [selected, setSelected] = useState(safetyAnswers || []);

//   const toggle = (id) => {
//     const q = questions.find(q => q.id === id);
//     if (q?.isNone) {
//       setSelected([id]);
//     } else {
//       setSelected(prev => {
//         const filtered = prev.filter(s => {
//           const sq = questions.find(q => q.id === s);
//           return !sq?.isNone;
//         });
//         return filtered.includes(id) ? filtered.filter(s => s !== id) : [...filtered, id];
//       });
//     }
//   };

//   const handleNext = () => {
//     setSafetyAnswers(selected);
//     // Check if any selected triggers emergency threshold
//     const totalWeight = selected.reduce((sum, id) => {
//       const q = questions.find(q => q.id === id);
//       return sum + (q?.weight || 0);
//     }, 0);
//     if (totalWeight >= SC.emergencyThreshold) {
//       onEmergency();
//     } else {
//       onNext();
//     }
//   };

//   const hasSelection = selected.length > 0;

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Safety Check" />
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{SC.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{SC.pageSubtitle}</p>
//         </div>
//         <div className={styles.screenHeaderIllustration}>
//           {/* <div style={{ fontSize: 56, textAlign: 'center' }}>🛡️</div> */}
//           <div className='h-20 w-16'>
//            <img src='/images/secureProfile.svg' style={{width:"100%"}} />
//            </div>
//         </div>
//       </div>

//       <div className={styles.twoCol}>
//         <div>
//           <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#92400e', display: 'flex', gap: 8, alignItems: 'center' }}>
//             <span>⚠️</span>{SC.emergencyNote}
//           </div>

//           <label className={styles.label}>Are you currently experiencing any of these?</label>
//           <div style={{ fontSize: 12, color: 'var(--fc-text-muted)', marginBottom: 12 }}>Select all that apply</div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//             {questions.map(q => {
//               const sel = selected.includes(q.id);
//               return (
//                 <div
//                   key={q.id}
//                   onClick={() => toggle(q.id)}
//                   className={`${styles.safetyOption} ${sel ? (q.isNone ? styles.safetyOptionNone : styles.safetyOptionUrgent) : ''}`}
//                 >
//                   <div className={styles.safetyOptionEmoji}>{q.emoji}</div>
//                   <div className={styles.safetyOptionLabel}>{q.label}</div>
//                   {sel && !q.isNone && <div style={{ marginLeft: 'auto', background: '#fee2e2', color: '#dc2626', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 20 }}>Flagged</div>}
//                   {sel && q.isNone && <div style={{ marginLeft: 'auto' }}><Check size={14} color="#16a34a" /></div>}
//                   {!sel && <div className={styles.safetyOptionRadio} />}
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         <div className={styles.sideCol}>
//           <SidePanel title={SC.sideCard.title} items={SC.sideCard.items} />
//           <div className={styles.sidePanelCard} style={{ marginTop: 12, background: '#fef3c7', border: '1px solid #fde68a' }}>
//             <div style={{ fontSize: 12, fontWeight: 600, color: '#92400e', marginBottom: 4 }}>Emergency</div>
//             <div style={{ fontSize: 12, color: '#78350f' }}>If symptoms are severe, call <strong>108</strong> or go to your nearest hospital immediately.</div>
//           </div>
//         </div>
//       </div>

//       <NavRow onBack={onBack} onNext={handleNext} disabled={!hasSelection} />
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 6b — EMERGENCY RECOMMENDATION
//    Shown when safety check triggers emergency threshold
// ═══════════════════════════════════════════════════════════════════ */
// function EmergencyScreen({ onBack }) {
//   const navigate = useNavigate();
//   const EM = CONFIG.screens.emergencyRecommendation;
//   return (
//     <div>
//       <div style={{ textAlign: 'center', padding: '20px 0 12px' }}>
//         <div style={{ fontSize: 64, marginBottom: 12 }}>🚨</div>
//         <h1 className={styles.pageTitle} style={{ color: '#dc2626' }}>{EM.pageTitle}</h1>
//         <p className={styles.pageSubtitle}>{EM.pageSubtitle}</p>
//       </div>

//       <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
//         {EM.actions.map(action => (
//           <button
//             key={action.id}
//             className={action.primary ? `${styles.btnPrimary} ${styles.btnOrange} ${styles.btnFull}` : `${styles.btnOutline} ${styles.btnFull}`}
//             style={{ padding: '14px 20px', fontSize: 15 }}
//             onClick={() => {
//               if (action.id === 'call_emergency') window.location.href = 'tel:108';
//               else if (action.id === 'speak_doctor') navigate(`/book-appointment?openModal=true&doctorId=doc-1`);
//             }}
//           >
//             <span style={{ marginRight: 8, fontSize: 18 }}>{action.icon}</span>
//             <div style={{ textAlign: 'left' }}>
//               <div style={{ fontWeight: 700 }}>{action.label}</div>
//               <div style={{ fontSize: 12, opacity: 0.85 }}>{action.desc}</div>
//             </div>
//           </button>
//         ))}
//       </div>

//       <div style={{ textAlign: 'center' }}>
//         <button className={styles.btnOutline} onClick={onBack} style={{ fontSize: 13 }}>
//           <ArrowLeft size={14} /> Go back and review symptoms
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 7 — ADAPTIVE INTAKE
//    Deep follow-up questions based on activeRoute entry reason
// ═══════════════════════════════════════════════════════════════════ */
// function AdaptiveIntakeScreen({ activeRoute, adaptiveAnswers, setAdaptiveAnswers, onNext, onBack, currentStep, totalSteps }) {
//   const AI = CONFIG.screens.adaptiveIntake;
//   const questions = getAdaptiveQuestions(activeRoute);
//   const [answers, setAnswers] = useState(adaptiveAnswers || {});
//   const [qIdx, setQIdx] = useState(0);

//   const currentQ = questions[qIdx];
//   const isLast = qIdx >= questions.length - 1;
//   const currentAnswer = answers[currentQ?.id];
//   const hasAnswer = Array.isArray(currentAnswer) ? currentAnswer.length > 0 : !!currentAnswer;

//   const handleNext = () => {
//     setAdaptiveAnswers({ ...answers });
//     if (isLast) { onNext(); }
//     else setQIdx(i => i + 1);
//   };
//   const handleBack = () => {
//     if (qIdx > 0) setQIdx(i => i - 1);
//     else onBack();
//   };
//   const setAnswer = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));

//   if (!currentQ) return null;

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label={`Adaptive Intake (${qIdx + 1}/${questions.length})`} />
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{AI.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{AI.pageSubtitle}</p>
//         </div>
//       </div>

//       {/* Sub-step progress dots */}
//       <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
//         {questions.map((_, i) => (
//           <div key={i} style={{ height: 4, flex: 1, borderRadius: 4, background: i <= qIdx ? 'var(--fc-purple)' : 'var(--fc-border)', transition: 'background 0.2s' }} />
//         ))}
//       </div>

//       <div className={styles.twoCol}>
//         <div>
//           <div className={styles.formGroup}>
//             <label className={styles.label} style={{ fontSize: 15, marginBottom: 16 }}>
//               {currentQ.label}
//             </label>

//             {currentQ.type === 'chipGroup' && (
//               <ChipGroup
//                 options={currentQ.options}
//                 value={answers[currentQ.id] || ''}
//                 onChange={val => setAnswer(currentQ.id, val)}
//                 columns={2}
//               />
//             )}

//             {currentQ.type === 'multiSelect' && (
//               <MultiChips
//                 options={currentQ.options}
//                 values={answers[currentQ.id] || []}
//                 onChange={vals => setAnswer(currentQ.id, vals)}
//               />
//             )}
//           </div>
//         </div>

//         <div className={styles.sideCol}>
//           <SidePanel title={AI.sideCard.title} items={AI.sideCard.items} />
//           <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
//             <div className={styles.sidePanelTitle}>Progress</div>
//             {questions.map((q, i) => (
//               <div key={q.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 0', color: i < qIdx ? '#16a34a' : i === qIdx ? 'var(--fc-purple)' : 'var(--fc-text-muted)', fontWeight: i === qIdx ? 600 : 400 }}>
//                 <span>{i < qIdx ? '✓' : i === qIdx ? '→' : '○'}</span>
//                 {q.label.slice(0, 36)}{q.label.length > 36 ? '…' : ''}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <NavRow
//         onBack={handleBack}
//         onNext={handleNext}
//         nextLabel={isLast ? 'See My Recommendations' : `Next (${qIdx + 1}/${questions.length})`}
//         disabled={!hasAnswer}
//       />
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    SCREEN 8 — RECOMMENDATION
// ═══════════════════════════════════════════════════════════════════ */
// function RecommendationScreen({ profile, journeyKey, onBack, currentStep, totalSteps }) {
//   const navigate = useNavigate();
//   const R = CONFIG.screens.recommendation;
//   const doc = R.doctor;
//   const [apptOpen, setApptOpen] = useState(false);

//   return (
//     <div>
//       <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Your Care Plan" />
//       <h1 className={styles.pageTitle} style={{ marginBottom: 4 }}>{R.stepTitle}</h1>
//       <p className={styles.pageSubtitle} style={{ marginBottom: 20 }}>
//         Hi {profile?.fullName || 'there'} — based on your answers, here's your personalised care plan.
//       </p>

//       <div className={styles.twoCol}>
//         <div>
//           {/* Program card */}
//           <div className={styles.recProgramCard}>
//             <div className={styles.recBestMatchBadge}><Verified size={13} color="#16a34a" /> {R.program.badgeLabel}</div>
//             <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>{R.program.basedOnText}</div>
//             <div className={styles.recProgramTitle}>{R.program.title}</div>
//             <div className={styles.recProgramDesc}>{R.program.description}</div>
//             <div className={styles.recTagRow}>
//               {R.program.tags.map(t => <span key={t} className={styles.recTag}>{t}</span>)}
//             </div>
//           </div>

//           {/* Doctor */}
//           <div className={styles.doctorCard}>
//             <div className={styles.doctorAvatar}>{doc.initials}</div>
//             <div style={{ flex: 1 }}>
//               <div className={styles.doctorName}>{doc.name}</div>
//               <div className={styles.doctorRole}>{doc.role}</div>
//               <div className={styles.doctorLoc}><MapPin size={13} color="#9ca3af" /> {doc.location}</div>
//             </div>
//             <div className={styles.doctorRating}><Star size={15} /><span className={styles.doctorRatingVal}>{doc.rating}</span></div>
//           </div>

//           {/* Action buttons */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
//             {R.actions.slice(0, 2).map(action => (
//               <button
//                 key={action.value}
//                 className={action.primary ? `${styles.btnPrimary} ${styles.btnFull}` : `${styles.btnOutline} ${styles.btnFull}`}
//                 style={{ justifyContent: 'flex-start', gap: 12, padding: '12px 16px' }}
//                 onClick={() => navigate(action.route)}
//               >
//                 <span style={{ fontSize: 20 }}>{action.emoji}</span>
//                 <div style={{ textAlign: 'left' }}>
//                   <div style={{ fontWeight: 700 }}>{action.label}</div>
//                   <div style={{ fontSize: 12, opacity: 0.8 }}>{action.desc}</div>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className={styles.sideCol}>
//           <SidePanel
//             title="What happens next"
//             items={[
//               { icon: '📅', title: 'Book your appointment', desc: 'Schedule with a specialist at your convenience.' },
//               { icon: '💊', title: 'Join a care program', desc: 'Structured support tailored to your journey.' },
//               { icon: '📊', title: 'Track your progress', desc: 'Monitor your health journey on your dashboard.' },
//             ]}
//             extra={
//               <div style={{ marginTop: 12 }}>
//                 <button
//                   className={`${styles.btnPrimary} ${styles.btnFull}`}
//                   onClick={() => navigate("/")}
//                 >
//                   Go to Dashboard <ArrowRight size={14} color="white" />
//                 </button>
//               </div>
//             }
//           />
//         </div>
//       </div>

//       {/* <NavRow onBack={onBack} onNext={() => window.location.href = CONFIG.app.dashboardUrl} nextLabel="Go to Dashboard" /> */}


//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    APPOINTMENT MODAL (unchanged from original, simplified)
// ═══════════════════════════════════════════════════════════════════ */
// function AppointmentModal({ AP, onClose }) {
//   const stripDates = buildDateStrip();
//   const [selIdx, setSelIdx] = useState(0);
//   const [selSlot, setSelSlot] = useState('');
//   const selDay = stripDates[selIdx];
//   const available = getAvailableSlots(selDay);
//   const fmtFull = d => `${['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()]}, ${d.getDate()} ${MONTH_NAMES[d.getMonth()]}`;

//   return (
//     <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
//       <div style={{ background: '#fff', borderRadius: 16, maxWidth: 480, width: '100%', padding: 24, position: 'relative' }}>
//         <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', cursor: 'pointer', fontSize: 20 }}>×</button>
//         <div style={{ fontWeight: 700, fontSize: 18, color: 'var(--fc-purple)', marginBottom: 4 }}>{AP.doctor.name}</div>
//         <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>{AP.doctor.role} · {AP.doctor.location}</div>

//         {/* Date strip */}
//         <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 8, marginBottom: 16 }}>
//           {stripDates.map((d, i) => (
//             <div key={i} onClick={() => { setSelIdx(i); setSelSlot(''); }}
//               style={{ minWidth: 52, padding: '8px 6px', borderRadius: 10, textAlign: 'center', cursor: 'pointer', border: `1.5px solid ${i === selIdx ? 'var(--fc-purple)' : '#e5e7eb'}`, background: i === selIdx ? 'var(--fc-purple-soft)' : '#fff' }}>
//               <div style={{ fontSize: 10, color: '#9ca3af' }}>{'Sun Mon Tue Wed Thu Fri Sat'.split(' ')[d.getDay()]}</div>
//               <div style={{ fontSize: 16, fontWeight: 700, color: i === selIdx ? 'var(--fc-purple)' : '#1a1a1a' }}>{d.getDate()}</div>
//             </div>
//           ))}
//         </div>

//         <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--fc-purple)', marginBottom: 8 }}>Available Time Slots · {fmtFull(selDay)}</div>
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 20 }}>
//           {available.length === 0 && <span style={{ fontSize: 12, color: '#6b7280', gridColumn: '1/-1', textAlign: 'center' }}>No slots available.</span>}
//           {available.map(slot => (
//             <div key={slot} onClick={() => setSelSlot(slot)} style={{ padding: '8px 4px', borderRadius: 8, textAlign: 'center', cursor: 'pointer', border: `1.5px solid ${selSlot === slot ? 'var(--fc-purple)' : '#e5e7eb'}`, background: selSlot === slot ? 'var(--fc-purple-soft)' : '#fff' }}>
//               <span style={{ fontSize: 11, fontWeight: 500, color: selSlot === slot ? 'var(--fc-purple)' : '#374151' }}>{slot}</span>
//             </div>
//           ))}
//         </div>
//         <button className={`${styles.btnPrimary} ${styles.btnFull}`} disabled={!selSlot} onClick={() => { if (selSlot) { onClose(); window.location.href = AP.successDashboardUrl; } }}>
//           Confirm Appointment  
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════════════
//    MAIN ORCHESTRATOR
// ═══════════════════════════════════════════════════════════════════ */
// const SCREEN_IDS = [
//   'welcome',       // 0
//   'consent',       // 1
//   'identify',      // 2
//   'lifeStage',     // 3
//   'entryReason',   // 4
//   'symptoms',      // 5
//   'safetyCheck',   // 6
//   'adaptive',      // 7
//   'recommendation',// 8
// ];

// export default function CareNavigator() {
//   const navigate = useNavigate();
//   const [screenIdx, setScreenIdx] = useState(0);
//   const [isEmergency, setIsEmergency] = useState(false);

//   // Patient profile (from identify screen)
//   const [profile, setProfile] = useState({ fullName: '', mobile: '', ageGroup: '', maritalStatus: '', occupation: '', height: 160, weight: 60 });

//   const [identifyState,
//     setIdentifyState] =
//     useState({
//       patientType: 'new',
//       mobile: '',
//       fullName: '',
//       otp: '',
//       otpSent: false,
//       otpVerified: false,
//       dob: '',
//       ageGroup: '',
//       marital: '',
//       occupation: '',
//       height: HEIGHT_DEFAULT_IN,
//       weight: WEIGHT_DEFAULT_KG,
//       profileSubStep: 0,
//       errors: {},
//       showLogin: false,
//     });

//   // Life stage answers
//   const [lifeStageAnswers, setLifeStageAnswers] = useState({});

//   // Entry reason
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [activeRoute, setActiveRoute] = useState('pcos');

//   // Symptoms
//   const [selectedSymptoms, setSelectedSymptoms] = useState([]);
//   const [symptomDuration, setSymptomDuration] = useState('');
//   const [symptomSeverity, setSymptomSeverity] = useState('');

//   // Safety check
//   const [safetyAnswers, setSafetyAnswers] = useState([]);

//   // Adaptive intake
//   const [adaptiveAnswers, setAdaptiveAnswers] = useState({});

//   const totalSteps = SCREEN_IDS.length;
//   const screen = isEmergency ? 'emergency' : SCREEN_IDS[screenIdx];

//   const next = useCallback(() => setScreenIdx(i => Math.min(SCREEN_IDS.length - 1, i + 1)), []);
//   const back = useCallback(() => setScreenIdx(i => Math.max(0, i - 1)), []);

//   const journeyKey = useMemo(() => classifyJourney(profile, lifeStageAnswers), [profile, lifeStageAnswers]);

//   return (
//     <>
//       <DigitalHealthFAB />
//       <div className={styles.page}>
//         <div className={styles.card}>
//           {screen === 'welcome' && (
//             <WelcomeScreen onStart={next} />
//           )}

//           {screen === 'consent' && (
//             <ConsentScreen onNext={next} onBack={back} config={CONSENT_CONFIG} />
//           )}

//           {screen === 'identify' && (
//             <IdentifyPatientScreen
//               onNext={next}
//               onBack={back}
//               setProfile={setProfile}
//               identifyState={
//                 identifyState
//               }

//               setIdentifyState={
//                 setIdentifyState
//               }
//             />
//           )}

//           {screen === 'lifeStage' && (
//             <LifeStageScreen
//               profile={profile}
//               lifeStageAnswers={lifeStageAnswers}
//               setLifeStageAnswers={setLifeStageAnswers}
//               onNext={next}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}

//           {screen === 'entryReason' && (
//             <EntryReasonScreen
//               profile={profile}
//               lifeStageAnswers={lifeStageAnswers}
//               selectedOptions={selectedOptions}
//               setSelectedOptions={setSelectedOptions}
//               setActiveRoute={setActiveRoute}
//               onNext={next}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}

//           {screen === 'symptoms' && (
//             <SymptomsScreen
//               profile={profile}
//               lifeStageAnswers={lifeStageAnswers}
//               selectedOptions={selectedOptions}
//               activeRoute={activeRoute}
//               selectedSymptoms={selectedSymptoms}
//               setSelectedSymptoms={setSelectedSymptoms}
//               symptomDuration={symptomDuration}
//               setSymptomDuration={setSymptomDuration}
//               symptomSeverity={symptomSeverity}
//               setSymptomSeverity={setSymptomSeverity}
//               onNext={next}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}

//           {screen === 'safetyCheck' && (
//             <SafetyCheckScreen
//               activeRoute={activeRoute}
//               safetyAnswers={safetyAnswers}
//               setSafetyAnswers={setSafetyAnswers}
//               onNext={next}
//               onEmergency={() => setIsEmergency(true)}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}

//           {screen === 'emergency' && (
//             <EmergencyScreen onBack={() => setIsEmergency(false)} />
//           )}

//           {screen === 'adaptive' && (
//             <AdaptiveIntakeScreen
//               activeRoute={activeRoute}
//               adaptiveAnswers={adaptiveAnswers}
//               setAdaptiveAnswers={setAdaptiveAnswers}
//               onNext={next}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}

//           {screen === 'recommendation' && (
//             <RecommendationScreen
//               profile={profile}
//               journeyKey={journeyKey}
//               onBack={back}
//               currentStep={screenIdx}
//               totalSteps={totalSteps}
//             />
//           )}
//         </div>
//       </div>
//     </>

//   );
// }

// CareNavigator.jsx — Complete Care Navigator v2.0
// Changes: (1) existing patient → OTP → redirect to dashboard
//          (2) new patient → name/mobile/OTP → chipGroup ageGroup/marital/occupation + sliders
//          (3) life stage questions driven by ageGroup + marital status
//          (4) entry reason → single auto-suggested journey, multi-option select
//          (5) symptoms by life stage route
//          (6) safety check max 3 questions with "Not sure" / "None" option
//          (7) emergency → direct recommendation; else adaptive intake
//          All screens: consistent left content + right side panel

'use client';

import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import styles from '../styles/carenavigator.module.css';
import CONFIG from '../config/carenavigator.json';
import { data, useNavigate } from 'react-router-dom';
import ConsentScreen from '../components/Reusablecomponents/Consentscreen/Consentscreen';
import { useAuth } from '../hooks/useAuth';
import { isMobileVerified, storePatientSession } from '../utils/storage/authStorage';
import { quickRegister, sendQuickOtp, verifyOtp } from '../api/auth.api';
import DigitalHealthFAB from '../components/Digitalhealth';
import { HEIGHT_DEFAULT_IN, HEIGHT_MAX_IN, HEIGHT_MIN_IN, WEIGHT_DEFAULT_KG, WEIGHT_MAX_KG, WEIGHT_MIN_KG } from '../config/constants';
import { ScreenHeaderDFO } from '../components/HealthAssessment/SharedUI';
import { BASE_URL } from '../api/apiClient';
import NewPatientScreen from '../components/CareJourney/Newpatientscreen';
import ProfileScreen from '../components/CareJourney/Profilescreen';
import HeightWeightScreen from '../components/CareJourney/Heightweightscreen';
// import { HeightWeightScreen, NewPatientScreen, ProfileScreen } from './HealthAssessmentJourney';


const CONSENT_CONFIG = {
  "pageTitle": "Consent & Privacy",
  "pageSubtitle": "Before we personalize your care navigator, please review how your information will be used.",
  "illustrationEmoji": "🛡️",
  "requiredItems": [
    { "id": "carePersonalization", "icon": "🤝", "title": "Care Navigator Personalization", "description": "Use my answers to personalize my women's health care navigator.", "type": "checkbox", "required": true },
    { "id": "clinicAccess", "icon": "👥", "title": "Clinic Care Team Access", "description": "Allow the selected clinic's authorized care team to view my submitted information.", "type": "checkbox", "required": true },
    { "id": "privacyNotice", "icon": "📋", "title": "Privacy Notice Acknowledgement", "description": "I have read and understand the privacy notice.", "type": "checkbox", "required": true }
  ],

  "sideCard": {
    "title": "Your privacy is our priority",
    "description": "We collect only what's necessary to provide safe, effective, and personalized care for you.",
    "items": [
      { "icon": "🛡️", "title": "Secure & Encrypted", "desc": "Your data is encrypted and stored securely." },
      { "icon": "🔒", "title": "Private by Design", "desc": "We limit access to your data to authorized care team members only." },
      { "icon": "👤", "title": "You're in Control", "desc": "You can manage or withdraw optional consent anytime." }
    ],
    "infoBubble": "You can manage optional consent later from your profile.",
    "ctaLabel": "Continue Securely"
  }
};
/* ═══════════════════════════════════════════════════════════════════
   ICONS
═══════════════════════════════════════════════════════════════════ */
const ArrowRight = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);
const ArrowLeft = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>
);
const Check = ({ size = 12, color = 'white' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={3} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);
const Lock = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);
const Star = ({ size = 15, color = '#facc15' }) => (
  <svg width={size} height={size} fill={color} viewBox="0 0 24 24">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);
const MapPin = ({ size = 13, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0zM19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);
const Calendar = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
  </svg>
);
const Clock = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" /><path strokeLinecap="round" d="M12 6v6l4 2" />
  </svg>
);
const ChevronDown = ({ size = 12 }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  </svg>
);
const Verified = ({ size = 13, color = '#16a34a' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
  </svg>
);

/* ═══════════════════════════════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════════════════════════════ */
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function fmt12({ h, m }) {
  const ampm = h < 12 ? 'AM' : 'PM';
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${h12}:${m === 0 ? '00' : '30'} ${ampm}`;
}

function buildDateStrip() {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Array.from({ length: 7 }, (_, i) => { const d = new Date(today); d.setDate(today.getDate() + i); return d; });
}

function getAvailableSlots(date) {
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  return CONFIG.appointment.slotHours
    .filter(s => {
      if (!isToday) return true;
      const st = new Date(date); st.setHours(s.h, s.m, 0, 0);
      return st.getTime() > now.getTime() + 30 * 60 * 1000;
    })
    .map(s => s.label || fmt12(s));
}

// Map ageGroup + maritalStatus + life-stage answers → journey key
function classifyJourney(profile, lifeStageAnswers) {
  const { ageGroup } = profile;
  const { currentlyPregnant, tryingToConceive, deliveredRecently, periodsStarted, lastPeriod } = lifeStageAnswers;

  if (deliveredRecently === 'Yes') return 'postpartum';
  if (currentlyPregnant === 'Yes') return 'pregnancy';
  if (currentlyPregnant === 'Not sure') return 'earlyPregnancy';
  if (tryingToConceive === 'Yes') return 'preconception';
  if (lastPeriod === 'No periods for 12+ months') return 'menopause';

  if (ageGroup === '65+ years') return 'senior';
  if (ageGroup === '55–64 years') return 'menopause';
  if (ageGroup === '46–55 years') return 'perimenopause';
  if (ageGroup === '36–45 years') return 'perimenopause';
  if (ageGroup === '10–14 years' || ageGroup === '15–19 years') return 'adolescence';
  if (tryingToConceive === 'Not sure' && (ageGroup === '26–35 years' || ageGroup === '20–25 years')) return 'reproductive';
  return 'reproductive';
}


// Derive safety check questions for a given route
function getSafetyQuestions(route) {
  const byRoute = CONFIG.screens.safetyCheck.byRoute;
  return byRoute[route] || byRoute.default;
}

// Derive adaptive questions for route
function getAdaptiveQuestions(route) {
  const byRoute = CONFIG.screens.adaptiveIntake.byRoute;
  return byRoute[route] || byRoute.default;
}

// Derive symptoms for route
function getSymptomsForRoute(route) {
  const byRoute = CONFIG.screens.symptoms.byRoute;
  return byRoute[route] || byRoute.default;
}

/* ═══════════════════════════════════════════════════════════════════
   SHARED COMPONENTS
═══════════════════════════════════════════════════════════════════ */
function ProgressBar({ currentStep, totalSteps, label }) {
  const pct = totalSteps > 1 ? Math.round((currentStep / (totalSteps - 1)) * 100) : 0;
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--fc-purple)' }}>{label}</span>
        <span style={{ fontSize: 12, color: 'var(--fc-text-muted)' }}>Step {currentStep + 1} of {totalSteps}</span>
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

function NavRow({ onBack, onNext, nextLabel = 'Continue', disabled = false, orange = false, footnote }) {
  return (
    <div>
      <div className={styles.navRow}>
        <button className={styles.btnOutline} onClick={onBack}>
          <ArrowLeft size={15} /> Back
        </button>
        <button
          className={`btn-primary ${styles.btnPrimary} ${orange ? styles.btnOrange : ''}`}
          onClick={onNext}
          disabled={disabled}
        >
          {nextLabel} <ArrowRight size={15} color="white" />
        </button>
      </div>
      {footnote && (
        <div className={styles.navFootnote}>
          <Lock size={13} /> {footnote}
        </div>
      )}
    </div>
  );
}

function Checkbox({ checked, onChange }) {
  return (
    <div
      className={`${styles.checkbox} ${checked ? styles.checked : ''}`}
      onClick={onChange}
      role="checkbox"
      aria-checked={checked}
    >
      {checked && <Check size={12} />}
    </div>
  );
}

function Toggle({ checked, onChange }) {
  return (
    <label className={styles.toggle}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <div className={styles.toggleTrack} />
      <div className={styles.toggleThumb} />
    </label>
  );
}

// Consistent right-side panel used on every screen
function SidePanel({ title, items, extra }) {
  return (
    <div className={styles.sidePanelCard}>
      {title && <div className={styles.sidePanelTitle}>{title}</div>}
      {items && (
        <div className={styles.sidePanelList}>
          {items.map((item, i) => (
            <div key={i} className={styles.sidePanelItem}>
              <div className={styles.sidePanelItemIcon}>{item.icon}</div>
              <div>
                <div className={styles.sidePanelItemTitle}>{item.title}</div>
                {item.desc && <div className={styles.sidePanelItemDesc}>{item.desc}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
      {extra}
    </div>
  );
}

// ChipGroup — single select with "Not sure" support
function ChipGroup({ options, value, onChange, columns = 2 }) {
  return (
    <div className={styles.chipGrid} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {options.map(opt => (
        <button
          key={opt}
          className={`${styles.chipCard} ${value === opt ? styles.chipCardActive : ''}`}
          onClick={() => onChange(opt)}
          type="button"
        >
          {value === opt && <span className={styles.chipCardCheck}><Check size={10} /></span>}
          {opt}
        </button>
      ))}
    </div>
  );
}

// MultiSelect chips
function MultiChips({ options, values, onChange }) {
  const toggle = (opt) => {
    if (opt === 'None of the above' || opt === 'None') {
      onChange([opt]);
    } else {
      const filtered = values.filter(v => v !== 'None of the above' && v !== 'None');
      if (filtered.includes(opt)) onChange(filtered.filter(v => v !== opt));
      else onChange([...filtered, opt]);
    }
  };
  return (
    <div className={styles.chipRow} style={{ flexWrap: 'wrap', gap: 8 }}>
      {options.map(opt => {
        const active = values.includes(opt);
        return (
          <button
            key={opt}
            className={`${styles.chip} ${styles.chipSymptom} ${active ? styles.chipSymptomActive : ''}`}
            onClick={() => toggle(opt)}
            type="button"
          >
            {active && <Verified size={12} color="#4a148c" />}
            {opt}
          </button>
        );
      })}
    </div>
  );
}

// OTP boxes
function OtpInput({ length = 6, value, onChange, error }) {
  const refs = useRef([]);
  const digits = value.split('');

  const handleChange = (i, v) => {
    if (!/^\d?$/.test(v)) return;
    const arr = digits.slice(0, length); arr[i] = v;
    while (arr.length < length) arr.push('');
    onChange(arr.join(''));
    if (v && i < length - 1) refs.current[i + 1]?.focus();
  };
  const handleKey = (i, e) => {
    if (e.key === 'Backspace' && !digits[i] && i > 0) refs.current[i - 1]?.focus();
  };

  return (
    <div>
      <div className={styles.otpRow}>
        {Array.from({ length }).map((_, i) => (
          <input
            key={i}
            ref={el => refs.current[i] = el}
            className={`${styles.otpBox} ${digits[i] ? styles.filled : ''}`}
            type="tel"
            maxLength={1}
            value={digits[i] || ''}
            onChange={e => handleChange(i, e.target.value)}
            onKeyDown={e => handleKey(i, e)}
          />
        ))}
      </div>
      {error && <div className={styles.errorText}>{error}</div>}
    </div>
  );
}

// Countdown resend
function ResendCountdown({ onResend }) {
  const [sec, setSec] = useState(60);
  useEffect(() => {
    if (sec <= 0) return;
    const t = setTimeout(() => setSec(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [sec]);
  return (
    <div style={{ fontSize: 12, color: 'var(--fc-text-muted)', textAlign: 'center', marginTop: 8 }}>
      Didn't receive it?{' '}
      {sec > 0
        ? <span>Resend in <strong style={{ color: 'var(--fc-purple)' }}>{sec}s</strong></span>
        : <span style={{ color: 'var(--fc-purple)', fontWeight: 600, cursor: 'pointer' }} onClick={() => { setSec(60); onResend?.(); }}>Resend OTP</span>
      }
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 0 — WELCOME
═══════════════════════════════════════════════════════════════════ */
function WelcomeScreen({ onStart, data }) {
  console.log(data, "this is the dataaaaaaaaa")
  const W = data?.screens?.welcome;
  const A = data?.app;
  if (!W) return null;                 // ← guard before using W.title, W.checklist, etc.

  return (
    <>
      <ScreenHeaderDFO />
      <div style={{ textAlign: 'center' }}>

        <div className={styles.welcomeHero}>
          <h2 className={styles.welcomeTitle}>{W.title}</h2>
          <p className={styles.welcomeSubtitle}>{W.subtitle}</p>
          <img src={W.imageSrc} alt={W.imageAlt} className={styles.welcomeImage} onError={e => { e.target.style.display = 'none'; }} />
        </div>
        <div className={styles.welcomeChecklist}>
          {W.checklist.map(text => (
            <div key={text} className={styles.welcomeCheckItem}>
              <div className={styles.welcomeCheckDot}><Star size={12} color="#4a148c" /></div>
              <span className={styles.welcomeCheckText}>{text}</span>
            </div>
          ))}
        </div>
        <div className={styles.welcomeCtaWrap}>
          <button className={`btn-primary ${styles.btnPrimary} ${styles.btnPrimaryRound} `} onClick={onStart}>
            {W.ctaLabel} <ArrowRight size={16} color="white" />
          </button>
        </div>
      </div>
    </>

  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 2 — IDENTIFY PATIENT
   Existing: mobile → OTP → redirect to dashboard
   New: name → mobile → OTP → one-question-at-a-time profile flow
═══════════════════════════════════════════════════════════════════ */
export const toFtIn = (inches) => {
  const ft = Math.floor(inches / 12);
  const ins = inches % 12;
  return `${ft}.${ins} ft`;
};
function IdentifyPatientScreen({ onNext, onBack, setProfile, identifyState, setIdentifyState, }) {
  const IP = CONFIG.screens.identifyPatient;
  const navigate = useNavigate();

  const {
    patientType,
    mobile,
    fullName,
    otp,
    otpSent,
    otpVerified,
    dob,
    ageGroup,
    marital,
    occupation,
    height,
    weight,
    profileSubStep,
    errors,
    showLogin
  } = identifyState;

  const { user } = useAuth();

  const updateIdentifyState = (
    data
  ) => {

    setIdentifyState(prev => ({
      ...prev,
      ...data,
    }));
  };

  const updateErrors = (
    data
  ) => {

    setIdentifyState(prev => ({
      ...prev,
      errors: data,
    }));
  };


  const isVerified = isMobileVerified(mobile || user?.mobile || '');
  const inProfileFlow = profileSubStep > 0;

  const isNew = patientType === 'new';
  const ntab = IP.tabs.new;
  const etab = IP.tabs.existing;

  // const bmi = height > 0 ? +(weight / ((height / 100) ** 2)).toFixed(1) : 0;
  const bmi = height > 0 ? +(weight / ((height * 0.0254) ** 2)).toFixed(1) : 0;
  const bmiCategory =
    bmi < 18.5 ? { label: 'Underweight', color: '#3b82f6', bg: '#eff6ff' }
      : bmi < 25 ? { label: 'Normal weight', color: '#16a34a', bg: '#f0fdf4' }
        : bmi < 30 ? { label: 'Overweight', color: '#d97706', bg: '#fffbeb' }
          : { label: 'Obese', color: '#dc2626', bg: '#fef2f2' };

  useEffect(() => {

    if (!user) return;

    updateIdentifyState({

      fullName:
        fullName ||
        user?.fullName ||
        '',

      mobile:
        mobile ||
        user?.mobile ||
        '',

      dob:
        dob ||
        user?.dob ||
        '',

      ageGroup:
        ageGroup ||
        user?.ageGroup ||
        '',

      marital:
        marital ||
        user?.maritalStatus ||
        '',

      occupation: occupation || user?.occupation || '',
      height: height || user?.height || HEIGHT_DEFAULT_IN,
      weight: weight || user?.weight || WEIGHT_DEFAULT_KG,
    });

  }, [user]);

  const updateIdentify =
    (data) => {

      setIdentifyState(
        prev => ({
          ...prev,
          ...data,
        })
      );
    };

  const firstIncompleteStep = () => {
    if (!ageGroup) return 1;
    if (!marital) return 2;
    if (!occupation) return 3;
    return 4;
  };


  const handleSendOtp =
    async () => {

      const errs = {};

      if (
        isNew &&
        !fullName.trim()
      ) {

        errs.fullName =
          'Full name is required';
      }

      if (
        !/^\d{10}$/.test(
          mobile
        )
      ) {

        errs.mobile =
          'Enter a valid 10-digit number';
      }

      if (
        Object.keys(errs)
          .length
      ) {

        updateErrors(errs);

        return;
      }

      updateErrors({});
      if (isVerified) {

        updateIdentifyState({

          otpVerified: true,

          profileSubStep: 1
        });

        return;
      }

      try {

        const res =
          await sendQuickOtp({

            fullName:
              fullName.trim(),

            mobileNumber:
              mobile.trim(),
          });

        if (res.success) {

          updateIdentifyState({

            otpSent: true,
          });

        } else {

          updateErrors({

            mobile:
              res.message ||
              'Failed to send OTP',
          });
        }

      } catch (err) {

        // updateErrors({

        //   mobile:
        //     err.message ||
        //     'Failed to send OTP',
        // });

        if (err?.message?.toLowerCase().includes('already registered') ||
          err?.message?.toLowerCase().includes('please login')) {
          updateIdentifyState({ showLogin: true });
          updateErrors({ mobile: err.message });
        } else {
          updateErrors({ mobile: err.message || 'Failed to send OTP' });
        }
      }
    };
  const handleVerifyOtp =
    async () => {

      if (
        otp.length < 6
      ) {

        updateErrors({

          otp:
            'Enter all 6 digits',
        });

        return;
      }

      updateErrors({});

      try {
        await verifyOtp({

          fullName,

          mobileNumber:
            mobile,

          otp,
        });
        const registerResponse =
          await quickRegister({

            fullName,

            mobileNumber:
              mobile,

            dob,

            otp,

            orgName:
              `Mukta Women's Clinic`,
          });
        storePatientSession({
          ...registerResponse.data,

          fullName,

          mobile,

          dob,

          isVerified:
            true,
        });
        updateIdentifyState({

          otpVerified:
            true,

          otpSent:
            true,

          profileSubStep:
            firstIncompleteStep(),
        });

      } catch (err) {

        updateErrors({

          otp:
            err.message ||
            'Verification failed',
        });
      }
    };


  const handleProfileNext =
    () => {
      if (
        profileSubStep === 1
      ) {

        if (!ageGroup) {

          updateErrors({

            ageGroup:
              'Please select your age group',
          });

          return;
        }

        storePatientSession({
          ageGroup,
        });

        updateErrors({});

        updateIdentifyState({
          profileSubStep: 2,
        });

        return;
      }
      if (
        profileSubStep === 2
      ) {

        if (!marital) {

          updateErrors({

            marital:
              'Please select marital status',
          });

          return;
        }

        storePatientSession({

          maritalStatus:
            marital,
        });

        updateErrors({});

        updateIdentifyState({
          profileSubStep: 3,
        });

        return;
      }

      if (
        profileSubStep === 3
      ) {

        if (!occupation) {

          updateErrors({

            occupation:
              'Please select occupation',
          });

          return;
        }

        storePatientSession({
          occupation,
        });

        updateErrors({});

        updateIdentifyState({
          profileSubStep: 4,
        });

        return;
      }

      if (
        profileSubStep === 4
      ) {

        storePatientSession({

          height,
          weight,
        });

        setProfile({

          fullName,
          mobile,

          ageGroup,

          maritalStatus:
            marital,

          occupation,

          height,
          weight,
        });

        onNext();
      }
    };

  const handleProfileBack =
    () => {
      updateErrors({});
      if (
        profileSubStep === 1
      ) {
        updateIdentifyState({
          profileSubStep: 0,
          otpSent:
            isVerified
              ? false
              : true,
        });
        return;
      }
      updateIdentifyState({
        profileSubStep:
          profileSubStep - 1,
      });
    };

  // ─── Side-panel extras (unchanged) ────────────────────────────────
  const existingBenefits = IP.existingBenefits;
  const sideItems = isNew
    ? [
      { icon: '👤', title: 'Create your profile', desc: 'Get personalised care tailored to your needs.' },
      { icon: '📁', title: 'Save your records', desc: 'Access reports and appointments anytime.' },
      { icon: '🔒', title: 'Secure & private', desc: 'Your data is encrypted end-to-end.' },
    ]
    : existingBenefits.items;

  const profileSubStepExtra =
    profileSubStep === 4 ? (
      <div style={{ marginTop: 12 }}>
        <div style={{ background: bmiCategory.bg, border: `1.5px solid ${bmiCategory.color}`, borderRadius: 12, padding: '14px 16px', marginBottom: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: bmiCategory.color, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Live BMI</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4 }}>
            <span style={{ fontSize: 32, fontWeight: 800, color: bmiCategory.color, lineHeight: 1 }}>{bmi}</span>
            <span style={{ fontSize: 13, color: bmiCategory.color, fontWeight: 600 }}>{bmiCategory.label}</span>
          </div>
          <div style={{ position: 'relative', height: 8, borderRadius: 4, background: 'linear-gradient(to right, #3b82f6 0%, #16a34a 30%, #d97706 60%, #dc2626 100%)', marginTop: 8, marginBottom: 6 }}>
            <div style={{
              position: 'absolute', top: '50%', transform: 'translate(-50%, -50%)',
              left: `${Math.min(Math.max(((bmi - 15) / (40 - 15)) * 100, 0), 100)}%`,
              width: 14, height: 14, borderRadius: '50%', background: '#fff',
              border: `2.5px solid ${bmiCategory.color}`, boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
            }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#9ca3af' }}>
            <span>15</span><span>18.5</span><span>25</span><span>30</span><span>40</span>
          </div>
        </div>
      </div>
    )
      : profileSubStep === 3
        ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>💼</span><span className={styles.consentInfoBubbleText}>Your occupation helps us recommend care that fits your lifestyle and schedule.</span></div>
        : profileSubStep === 2
          ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>💍</span><span className={styles.consentInfoBubbleText}>Marital status helps us understand your life stage and personalise your care journey.</span></div>
          : profileSubStep === 1
            ? <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}><span>🎂</span><span className={styles.consentInfoBubbleText}>Age helps us show you the most relevant health topics and care options.</span></div>
            : null;

  // ─── Render (unchanged structure) ─────────────────────────────────
  return (
    <div>
      <ScreenHeaderDFO />

      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{IP.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{IP.pageSubtitle}</p>
        </div>
        {/* <div className={styles.screenHeaderIllustration}>
          <div style={{ fontSize: 72, textAlign: 'center' }}>👩‍💻</div>
        </div> */}
        <img src='/images/profile.svg' className='h-20 w-20' />
      </div>

      <div className={styles.twoCol}>
        <div>

          {/* ── PROFILE SUB-STEPS ── */}
          {inProfileFlow ? (
            <div className={styles.sectionBox}>
              <div className={styles.sectionBoxLabel}>
                Complete your profile · Question {profileSubStep} of 4
              </div>

              {profileSubStep === 1 && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>What's your age group?</label>
                  <ChipGroup
                    options={ntab.ageGroupOptions}
                    value={ageGroup}
                    onChange={v => updateIdentify({
                      ageGroup: v
                    })}
                    columns={3}
                  />
                  {errors.ageGroup && <div className={styles.errorText}>{errors.ageGroup}</div>}
                </div>
              )}

              {profileSubStep === 2 && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>What's your marital status?</label>
                  <ChipGroup
                    options={ntab.maritalOptions}
                    value={marital}
                    onChange={v => updateIdentify({
                      marital: v
                    })}
                    columns={3}
                  />
                  {errors.marital && <div className={styles.errorText}>{errors.marital}</div>}
                </div>
              )}

              {profileSubStep === 3 && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>Nice 👍 What best describes your occupation?</label>
                  <ChipGroup
                    options={ntab.occupationOptions}
                    value={occupation}
                    onChange={v => updateIdentify({
                      occupation: v
                    })}
                    columns={3}
                  />
                  {errors.occupation && <div className={styles.errorText}>{errors.occupation}</div>}
                </div>
              )}

              {profileSubStep === 4 && (
                <>
                  <div className={styles.formGroup}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <label className={styles.label} style={{ margin: 0 }}>What's your height?</label>
                      <span className={styles.sliderValue}>{toFtIn(height)} </span>
                    </div>
                    <input
                      className={styles.rangeSlider}
                      type="range"
                      min={toFtIn(HEIGHT_MIN_IN)} max={toFtIn(HEIGHT_MAX_IN)} step={1}
                      value={height}
                      onChange={e => updateIdentifyState({
                        height:
                          Number(
                            e.target.value
                          ),
                      })}
                    />
                    <div className={styles.rangeLabels}><span>{toFtIn(ntab.heightMin)} </span><span>{toFtIn(ntab.heightMax)} </span></div>
                  </div>

                  <div className={styles.formGroup}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <label className={styles.label} style={{ margin: 0 }}>What's your weight?</label>
                      <span className={styles.sliderValue}>{weight} kg</span>
                    </div>
                    <input
                      className={styles.rangeSlider}
                      type="range"
                      min={WEIGHT_MIN_KG} max={WEIGHT_MAX_KG} step={1}
                      value={weight}
                      onChange={e => updateIdentifyState({
                        weight: Number(e.target.value)
                      })}
                    />
                    <div className={styles.rangeLabels}><span>{WEIGHT_MIN_KG} kg</span><span>{WEIGHT_MAX_KG} kg</span></div>
                  </div>
                </>
              )}
            </div>

          ) : (
            /* ── OTP / MOBILE FORM ── */
            <div className={styles.sectionBox}>
              <div className={styles.sectionBoxLabel}>Find or create your profile</div>

              {isNew && !otpSent && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>{ntab.fullNameLabel}</label>
                  <input
                    className={`${styles.input} ${errors.fullName ? styles.error : ''}`}
                    type="text"
                    placeholder={ntab.fullNamePlaceholder}
                    value={fullName}
                    onChange={e => updateIdentify({
                      fullName: e.target.value
                    })}
                  />
                  {errors.fullName && <div className={styles.errorText}>{errors.fullName}</div>}
                </div>
              )}

              {!otpSent && (
                <>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Mobile Number</label>
                    <span className={styles.hint}>We'll send a one-time password (OTP) to verify your number</span>
                    <div className={`${styles.phoneWrap} ${errors.mobile ? styles.error : ''}`} style={{ marginTop: 6 }}>
                      <div className={styles.phoneCode}>🇮🇳 +91</div>
                      <input
                        className={styles.phoneInput}
                        type="tel"
                        placeholder="Enter 10-digit mobile number"
                        maxLength={10}
                        value={mobile}
                        onChange={e => updateIdentify({
                          mobile: e.target.value.replace(/\D/g, '')
                        })}
                      />
                    </div>
                    {/* {errors.mobile && <div className={styles.errorText}>{errors.mobile}</div>} */}
                    {errors.mobile && <div className={`${styles.errorText} flex justify-between items-center`}
                    >{errors.mobile}

                      {showLogin && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <button
                            type="button"
                            className="ava-text-caption   hover:underline bg-transparent border-none p-0 cursor-pointer animate-bounce"
                            onClick={() => {
                              // updateIdentifyState({ patientType: 'existing', showLogin: false });
                              // updateErrors({});
                              navigate('/sign-in')
                            }}
                            style={{ color: "var(--primary-color)" }}
                          >
                            Login instead
                          </button>
                        </div>
                      )}
                    </div>}

                  </div>

                  {!isNew && (
                    <div className={styles.securityBox} style={{ marginTop: 12 }}>
                      <span className={styles.securityBoxIcon}>🔒</span>
                      <span className={styles.securityBoxText}>{etab.securityNote}</span>
                    </div>
                  )}
                  <div className={styles.navRow} style={{ marginTop: 16 }}>
                    <button className={styles.btnOutline} onClick={onBack}>
                      <ArrowLeft size={15} /> Back
                    </button>
                    <button className={`btn-primary ${styles.btnPrimary}`} onClick={handleSendOtp}>
                      {isVerified ? ntab.continueLabel : isNew ? ntab.sendOtpLabel : etab.sendOtpLabel} <ArrowRight size={15} color="white" />
                    </button>
                  </div>
                </>
              )}

              {otpSent && (
                <div>
                  <div style={{ fontSize: 13, color: 'var(--fc-text-muted)', marginBottom: 12, textAlign: 'center' }}>
                    OTP sent to <strong style={{ color: 'var(--fc-purple)' }}>+91 {mobile}</strong>
                    <button
                      style={{ background: 'none', border: 'none', color: 'var(--fc-purple)', fontSize: 12, cursor: 'pointer', marginLeft: 8 }}
                      // onClick={() => { setOtpSent(false); setOtp(''); setErrors({}); }}
                      onClick={() => updateIdentifyState({
                        otpSent: false,
                        otp: '',
                      })}
                    >
                      Change
                    </button>
                  </div>
                  <label className={styles.label} style={{ textAlign: 'center', display: 'block', marginBottom: 8 }}>Enter OTP</label>
                  <OtpInput length={6} value={otp} onChange={value =>
                    updateIdentifyState({
                      otp: value,
                    })
                  }
                    error={
                      errors.otp
                    } />
                  <ResendCountdown />
                  <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <button className={`btn-primary ${styles.btnPrimary}`} onClick={handleVerifyOtp}>
                      {isNew ? 'Verify & Continue' : 'Verify & Go to Dashboard'} <ArrowRight size={15} color="white" />
                    </button>
                  </div>
                  {!isNew && (
                    <div style={{ fontSize: 11, color: 'var(--fc-text-muted)', textAlign: 'center', marginTop: 8 }}>
                      You'll be redirected to your patient dashboard after verification.
                    </div>
                  )}
                  <div className={styles.navRow} style={{ marginTop: 16 }}>
                    <button className={styles.btnOutline} onClick={() => updateIdentifyState({
                      otpSent: false,
                      otp: '',
                    })}>
                      <ArrowLeft size={15} /> Back
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Right panel */}
        <div className={styles.sideCol}>
          <SidePanel
            title={isNew ? 'New Patient Benefits' : existingBenefits.title}
            items={sideItems}
            extra={profileSubStepExtra}
          />
        </div>

        {/* Per-step Back / Next */}
        {inProfileFlow && (
          <div className={styles.navRow} style={{ marginTop: 8 }}>
            <button className={styles.btnOutline} onClick={handleProfileBack}>
              <ArrowLeft size={15} /> Back
            </button>
            <button className={`btn-primary ${styles.btnPrimary}`} onClick={handleProfileNext}>
              {profileSubStep === 4 ? 'Continue' : 'Next'} <ArrowRight size={15} color="white" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 3 — LIFE STAGE QUESTIONS
   Driven by ageGroup + marital status from profile
═══════════════════════════════════════════════════════════════════ */
function LifeStageScreen({ data, profile, lifeStageAnswers, setLifeStageAnswers, onNext, onBack, currentStep, totalSteps }) {
  const LS = data.screens.lifeStage;
  const today = new Date().toISOString().split("T")[0];
  const [answers, setAnswers] = useState(lifeStageAnswers || {});

  // Filter questions based on ageGroup
  const filteredQuestions = useMemo(() => {
    return LS.questions.filter(q => {
      if (q.showForAgeGroups && !q.showForAgeGroups.includes(profile.ageGroup)) return false;
      if (q.showIf) {
        return Object.entries(q.showIf).every(([key, vals]) => vals.includes(answers[key]));
      }
      return true;
    });
  }, [LS.questions, profile.ageGroup, answers]);

  const setAnswer = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));

  const allAnswered = filteredQuestions.every(q => {
    if (q.type === 'dateOrSelect') return answers[q.id] != null;
    return !!answers[q.id];
  });

  const handleNext = () => {
    setLifeStageAnswers(answers);
    onNext();
  };

  return (
    <div>
      <ScreenHeaderDFO />

      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Life Stage" />
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{LS.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{LS.pageSubtitle}</p>
        </div>
        <div className={styles.screenHeaderIllustration}>
          <div style={{ fontSize: 60, textAlign: 'center' }}>🩺</div>
        </div>
      </div>

      <div className={styles.twoCol}>
        <div>
          {filteredQuestions.map((q, idx) => (
            <div key={q.id} className={styles.formGroup}>
              <label className={styles.label}>
                <span style={{ color: 'var(--fc-purple)', marginRight: 6, fontWeight: 700 }}>{idx + 1}.</span>
                {q.text}
              </label>
              {q.type === 'dateOrSelect' ? (
                <div>
                  <input
                    className={styles.input}
                    type="date"
                    max={today}
                    value={answers[q.id] && !q.alternateOptions?.includes(answers[q.id]) ? answers[q.id] : ''}
                    onChange={e => setAnswer(q.id, e.target.value)}
                    style={{ marginBottom: 8 }}
                  />
                  <div className={styles.chipRow} style={{ flexWrap: 'wrap', gap: 8 }}>
                    {q.alternateOptions.map(opt => (
                      <button
                        key={opt}
                        className={`${styles.chip} ${answers[q.id] === opt ? styles.chipActive : ''}`}
                        onClick={() => setAnswer(q.id, opt)}
                        type="button"
                      >{opt}</button>
                    ))}
                  </div>
                </div>
              ) : (
                <ChipGroup
                  options={q.options}
                  value={answers[q.id] || ''}
                  onChange={val => setAnswer(q.id, val)}
                  columns={q.options.length <= 3 ? q.options.length : 3}
                />
              )}
            </div>
          ))}
        </div>

        <div className={styles.sideCol}>
          {/* <SidePanel title={LS.sideCard.title} items={LS.sideCard.items} /> */}

          {/* Profile summary card */}
          <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
            <div className={styles.sidePanelTitle}>Your Profile</div>
            {[
              { label: 'Name', val: profile.fullName },
              { label: 'Age Group', val: profile.ageGroup },
              { label: 'Marital Status', val: profile.maritalStatus },
              { label: 'Occupation', val: profile.occupation },
              { label: 'Height', val: `${profile.height} cm` },
              { label: 'Weight', val: `${profile.weight} kg` },
            ].map(({ label, val }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--fc-border)' }}>
                <span style={{ color: 'var(--fc-text-muted)' }}>{label}</span>
                <span style={{ fontWeight: 600, color: 'var(--fc-text)' }}>{val || '—'}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <NavRow onBack={onBack} onNext={handleNext} disabled={!allAnswered} footnote="Your answers are private and encrypted." />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 4 — ENTRY REASON
   Auto-suggests ONE journey from life-stage; shows that journey's options
   Patient selects one or multiple options → each has a route
═══════════════════════════════════════════════════════════════════ */
function EntryReasonScreen({ profile, lifeStageAnswers, selectedOptions, setSelectedOptions, setActiveRoute, onNext, onBack, currentStep, totalSteps }) {
  const [ER, setER] = useState({})
  // const ER = CONFIG.screens.entryReason;
  useEffect(() => {
    console.log("in useffect fetch")
    const fetchJson = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/care-navigator/?clinic=mukta`);
        const data = await res.json();
        setER(data.screens.entryReason)
      } catch (error) {
        console.log(error, "this is the errorr")
      }
    }
    fetchJson();
  }, [])
  // Classify journey
  const journeyKey = useMemo(() => classifyJourney(profile, lifeStageAnswers), [profile, lifeStageAnswers]);
  // const journey = ER.journeys[journeyKey];
  if (!ER?.journeys) {
    return <div>Loading...</div>;
  }
  const journey = ER.journeys[journeyKey];
  const toggle = (optId) => {
    setSelectedOptions(prev =>
      prev.includes(optId) ? prev.filter(id => id !== optId) : [...prev, optId]
    );
  };

  const handleNext = () => {
    // Determine primary route from first selected option
    const firstOpt = journey.options.find(o => selectedOptions.includes(o.id));
    if (firstOpt) setActiveRoute(firstOpt.route);
    onNext();
  };

  if (!journey) return null;

  return (
    <div>
      <ScreenHeaderDFO />
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Entry Reason" />
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{ER.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{ER.pageSubtitle}</p>
        </div>
      </div>

      <div className={styles.twoCol}>
        <div>
          {/* Auto-suggested journey badge */}
          <div className={styles.journeyBadgeWrap}>
            <div className={styles.journeyBadge} style={{ borderColor: journey.color, color: journey.color }}>
              <span style={{ fontSize: 18 }}>{journey.icon}</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{journey.label}</div>
                <div style={{ fontSize: 11, opacity: 0.8 }}>{journey.ageRange}</div>
              </div>
              <div className={styles.journeyBadgeSuggest}>
                <Verified size={13} color={journey.color} /> {ER.autoSuggestNote}
              </div>
            </div>
          </div>

          <div style={{ fontSize: 13, color: 'var(--fc-text-muted)', marginBottom: 14, marginTop: 4 }}>
            Select one or more options that best match your concern today:
          </div>

          {/* Options */}
          <div className={styles.entryReasonGrid}>
            {journey.options.map(opt => {
              const sel = selectedOptions.includes(opt.id);
              return (
                <div
                  key={opt.id}
                  className={`${styles.entryReasonCard} ${sel ? styles.selected : ''} ${opt.urgent ? styles.urgentCard : ''}`}
                  onClick={() => toggle(opt.id)}
                >
                  {sel && <div className={styles.entryReasonCheck}><Check size={10} /></div>}
                  {opt.urgent && <div className={styles.urgentBadge}>🚨 Urgent</div>}
                  <div className={styles.entryReasonIcon}>{opt.icon}</div>
                  <div className={styles.entryReasonLabel}>{opt.label}</div>
                  <div className={styles.entryReasonDesc}>{opt.desc}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.sideCol}>
          <div className={styles.sidePanelCard} style={{ marginBottom: 12 }}>
            <div className={styles.sidePanelTitle}>Your Profile</div>
            {[
              { label: 'Name', val: profile.fullName },
              { label: 'Age Group', val: profile.ageGroup },
              { label: 'Marital Status', val: profile.maritalStatus },
              { label: 'Occupation', val: profile.occupation },
              { label: 'Height', val: `${profile.height} cm` },
              { label: 'Weight', val: `${profile.weight} kg` },
            ].map(({ label, val }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--fc-border)' }}>
                <span style={{ color: 'var(--fc-text-muted)' }}>{label}</span>
                <span style={{ fontWeight: 600, color: 'var(--fc-text)' }}>{val || '—'}</span>
              </div>
            ))}
          </div>
          <SidePanel
            title="Your matched journey"
            items={[
              // { icon: journey.icon, title: journey.label, desc: `Age range: ${journey.ageRange}` },
              // { icon: '🎯', title: 'Based on your answers', desc: 'We matched this journey from your life-stage responses.' },
              { icon: '🔄', title: 'You can select multiple', desc: 'Choose all concerns that apply to you today.' },
            ]}
            extra={
              selectedOptions.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--fc-purple)', marginBottom: 6 }}>Selected ({selectedOptions.length})</div>
                  {selectedOptions.map(id => {
                    const opt = journey.options.find(o => o.id === id);
                    return opt ? (
                      <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--fc-text)', marginBottom: 4 }}>
                        <span>{opt.icon}</span> {opt.label}
                      </div>
                    ) : null;
                  })}
                </div>
              )
            }
          />
        </div>
      </div>

      <NavRow onBack={onBack} onNext={handleNext} disabled={selectedOptions.length === 0} />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 5 — SYMPTOMS
   Based on activeRoute from entry reason
═══════════════════════════════════════════════════════════════════ */
function SymptomsScreen({data, profile, activeRoute, selectedSymptoms, setSelectedSymptoms, symptomDuration, setSymptomDuration, symptomSeverity, setSymptomSeverity, onNext, onBack, currentStep, totalSteps }) {
  const S = data.screens.symptoms;
  const options = getSymptomsForRoute(activeRoute);
  const toggle = (sym) => {
    setSelectedSymptoms(prev => prev.includes(sym) ? prev.filter(s => s !== sym) : [...prev, sym]);
  };

  return (
    <div>
      <ScreenHeaderDFO />

      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Symptoms" />
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{S.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{S.pageSubtitle}</p>
        </div>
        <div className={styles.screenHeaderIllustration}>
          <div style={{ fontSize: 56, textAlign: 'center' }}>🩺</div>
        </div>
      </div>

      <div className={styles.twoCol}>
        <div>
          {/* Symptoms multi-select */}
          <div className={styles.formGroup}>
            <label className={styles.label}>What symptoms are you experiencing?</label>
            <div className={styles.symptomsGrid}>
              {options.map(sym => {
                const sel = selectedSymptoms.includes(sym);
                return (
                  <div
                    key={sym}
                    className={`${styles.symptomCard} ${sel ? styles.selected : ''}`}
                    onClick={() => toggle(sym)}
                  >
                    {sel && <div className={styles.symptomCardCheck}><Check size={10} /></div>}
                    <span className={styles.symptomCardLabel}>{sym}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Duration */}
          <div className={styles.formGroup}>
            <label className={styles.label}>How long have you had these symptoms?</label>
            <div className={styles.chipRow} style={{ flexWrap: 'wrap', gap: 8 }}>
              {S.durationOptions.map(d => (
                <button
                  key={d}
                  className={`${styles.chip} ${symptomDuration === d ? styles.chipActive : ''}`}
                  onClick={() => setSymptomDuration(d)}
                  type="button"
                >{d}</button>
              ))}
            </div>
          </div>

          {/* Severity */}
          <div className={styles.formGroup}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <label className={styles.label} style={{ margin: 0 }}>Severity</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {S.severityOptions.map(sv => (
                  <button
                    key={sv.value}
                    onClick={() => setSymptomSeverity(sv.value)}
                    style={{
                      padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                      border: `1.5px solid ${sv.color}`,
                      background: symptomSeverity === sv.value ? sv.color : 'transparent',
                      color: symptomSeverity === sv.value ? '#fff' : sv.color,
                    }}
                  >{sv.label}</button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.sideCol}>
          {/* <SidePanel title={S.sideCard.title} items={S.sideCard.items} /> */}
          <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
            <div className={styles.sidePanelTitle}>Your Profile</div>
            {[
              { label: 'Name', val: profile.fullName },
              { label: 'Age Group', val: profile.ageGroup },
              { label: 'Marital Status', val: profile.maritalStatus },
              { label: 'Occupation', val: profile.occupation },
              { label: 'Height', val: `${profile.height} cm` },
              { label: 'Weight', val: `${profile.weight} kg` },
            ].map(({ label, val }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid var(--fc-border)' }}>
                <span style={{ color: 'var(--fc-text-muted)' }}>{label}</span>
                <span style={{ fontWeight: 600, color: 'var(--fc-text)' }}>{val || '—'}</span>
              </div>
            ))}
          </div>

          {selectedSymptoms.length > 0 && (
            <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
              <div className={styles.sidePanelTitle}>Selected symptoms ({selectedSymptoms.length})</div>
              {selectedSymptoms.map(s => (
                <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, padding: '3px 0' }}>
                  <span style={{ color: '#16a34a' }}>✓</span> {s}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <NavRow onBack={onBack} onNext={onNext} disabled={selectedSymptoms.length === 0} />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 6 — SAFETY CHECK
   Max 3 questions per route. Last option always "None of above / Not sure"
═══════════════════════════════════════════════════════════════════ */
function SafetyCheckScreen({ data,activeRoute, safetyAnswers, setSafetyAnswers, onNext, onEmergency, onBack, currentStep, totalSteps }) {
  const SC = data.screens.safetyCheck;
  const allQuestions = getSafetyQuestions(activeRoute);
  // Cap at 3 questions (the "none" option is mandatory last)
  const noneQ = allQuestions.find(q => q.isNone);
  const urgentQs = allQuestions.filter(q => !q.isNone).slice(0, 2); // max 2 urgent + 1 none = 3
  const questions = noneQ ? [...urgentQs, noneQ] : urgentQs;

  const [selected, setSelected] = useState(safetyAnswers || []);

  const toggle = (id) => {
    const q = questions.find(q => q.id === id);
    if (q?.isNone) {
      setSelected([id]);
    } else {
      setSelected(prev => {
        const filtered = prev.filter(s => {
          const sq = questions.find(q => q.id === s);
          return !sq?.isNone;
        });
        return filtered.includes(id) ? filtered.filter(s => s !== id) : [...filtered, id];
      });
    }
  };

  const handleNext = () => {
    setSafetyAnswers(selected);
    // Check if any selected triggers emergency threshold
    const totalWeight = selected.reduce((sum, id) => {
      const q = questions.find(q => q.id === id);
      return sum + (q?.weight || 0);
    }, 0);
    if (totalWeight >= SC.emergencyThreshold) {
      onEmergency();
    } else {
      onNext();
    }
  };

  const hasSelection = selected.length > 0;

  return (
    <div>
      <ScreenHeaderDFO />

      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Safety Check" />
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{SC.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{SC.pageSubtitle}</p>
        </div>
        <div className={styles.screenHeaderIllustration}>
          <div style={{ fontSize: 56, textAlign: 'center' }}>🛡️</div>
        </div>
      </div>

      <div className={styles.twoCol}>
        <div>
          <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#92400e', display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>⚠️</span>{SC.emergencyNote}
          </div>

          <label className={styles.label}>Are you currently experiencing any of these?</label>
          <div style={{ fontSize: 12, color: 'var(--fc-text-muted)', marginBottom: 12 }}>Select all that apply</div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {questions.map(q => {
              const sel = selected.includes(q.id);
              return (
                <div
                  key={q.id}
                  onClick={() => toggle(q.id)}
                  className={`${styles.safetyOption} ${sel ? (q.isNone ? styles.safetyOptionNone : styles.safetyOptionUrgent) : ''}`}
                >
                  <div className={styles.safetyOptionEmoji}>{q.emoji}</div>
                  <div className={styles.safetyOptionLabel}>{q.label}</div>
                  {sel && !q.isNone && <div style={{ marginLeft: 'auto', background: '#fee2e2', color: '#dc2626', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 20 }}>Flagged</div>}
                  {sel && q.isNone && <div style={{ marginLeft: 'auto' }}><Check size={14} color="#16a34a" /></div>}
                  {!sel && <div className={styles.safetyOptionRadio} />}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.sideCol}>
          <SidePanel title={SC.sideCard.title} items={SC.sideCard.items} />
          <div className={styles.sidePanelCard} style={{ marginTop: 12, background: '#fef3c7', border: '1px solid #fde68a' }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#92400e', marginBottom: 4 }}>Emergency</div>
            <div style={{ fontSize: 12, color: '#78350f' }}>If symptoms are severe, call <strong>108</strong> or go to your nearest hospital immediately.</div>
          </div>
        </div>
      </div>

      <NavRow onBack={onBack} onNext={handleNext} disabled={!hasSelection} />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 6b — EMERGENCY RECOMMENDATION
   Shown when safety check triggers emergency threshold
═══════════════════════════════════════════════════════════════════ */
function EmergencyScreen({ onBack, data }) {
  const navigate = useNavigate();
  const EM = data;
  return (
    <div>
      <ScreenHeaderDFO />

      <div style={{ textAlign: 'center', padding: '20px 0 12px' }}>
        <div style={{ fontSize: 64, marginBottom: 12 }}>🚨</div>
        <h1 className={styles.pageTitle} style={{ color: '#dc2626' }}>{EM.pageTitle}</h1>
        <p className={styles.pageSubtitle}>{EM.pageSubtitle}</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
        {EM.actions.map(action => (
          <button
            key={action.id}
            className={action.primary ? `${styles.btnPrimary} btn-primary ${styles.btnOrange} ${styles.btnFull}` : `${styles.btnOutline} ${styles.btnFull}`}
            style={{ padding: '14px 20px', fontSize: 15 }}
            onClick={() => {
              if (action.id === 'call_emergency') window.location.href = 'tel:108';
              else if (action.id === 'speak_doctor') navigate("/book-appointment");
            }}
          >
            <span style={{ marginRight: 8, fontSize: 18 }}>{action.icon}</span>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontWeight: 700 }}>{action.label}</div>
              <div style={{ fontSize: 12, opacity: 0.85 }}>{action.desc}</div>
            </div>
          </button>
        ))}
      </div>

      <div style={{ textAlign: 'center' }}>
        <button className={styles.btnOutline} onClick={onBack} style={{ fontSize: 13 }}>
          <ArrowLeft size={14} /> Go back and review symptoms
        </button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 7 — ADAPTIVE INTAKE
   Deep follow-up questions based on activeRoute entry reason
═══════════════════════════════════════════════════════════════════ */
function AdaptiveIntakeScreen({data, activeRoute, adaptiveAnswers, setAdaptiveAnswers, onNext, onBack, currentStep, totalSteps }) {
  const AI = data.screens.adaptiveIntake;
  const questions = getAdaptiveQuestions(activeRoute);
  const [answers, setAnswers] = useState(adaptiveAnswers || {});
  const [qIdx, setQIdx] = useState(0);

  const currentQ = questions[qIdx];
  const isLast = qIdx >= questions.length - 1;
  const currentAnswer = answers[currentQ?.id];
  const hasAnswer = Array.isArray(currentAnswer) ? currentAnswer.length > 0 : !!currentAnswer;

  const handleNext = () => {
    setAdaptiveAnswers({ ...answers });
    if (isLast) { onNext(); }
    else setQIdx(i => i + 1);
  };
  const handleBack = () => {
    if (qIdx > 0) setQIdx(i => i - 1);
    else onBack();
  };
  const setAnswer = (id, val) => setAnswers(prev => ({ ...prev, [id]: val }));

  if (!currentQ) return null;

  return (
    <div>
      <ScreenHeaderDFO />
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label={`Adaptive Intake (${qIdx + 1}/${questions.length})`} />
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{AI.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{AI.pageSubtitle}</p>
        </div>
      </div>

      {/* Sub-step progress dots */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
        {questions.map((_, i) => (
          <div key={i} style={{ height: 4, flex: 1, borderRadius: 4, background: i <= qIdx ? 'var(--fc-purple)' : 'var(--fc-border)', transition: 'background 0.2s' }} />
        ))}
      </div>

      <div className={styles.twoCol}>
        <div>
          <div className={styles.formGroup}>
            <label className={styles.label} style={{ fontSize: 15, marginBottom: 16 }}>
              {currentQ.label}
            </label>

            {currentQ.type === 'chipGroup' && (
              <ChipGroup
                options={currentQ.options}
                value={answers[currentQ.id] || ''}
                onChange={val => setAnswer(currentQ.id, val)}
                columns={2}
              />
            )}

            {currentQ.type === 'multiSelect' && (
              <MultiChips
                options={currentQ.options}
                values={answers[currentQ.id] || []}
                onChange={vals => setAnswer(currentQ.id, vals)}
              />
            )}
          </div>
        </div>

        <div className={styles.sideCol}>
          <SidePanel title={AI.sideCard.title} items={AI.sideCard.items} />
          <div className={styles.sidePanelCard} style={{ marginTop: 12 }}>
            <div className={styles.sidePanelTitle}>Progress</div>
            {questions.map((q, i) => (
              <div key={q.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 0', color: i < qIdx ? '#16a34a' : i === qIdx ? 'var(--fc-purple)' : 'var(--fc-text-muted)', fontWeight: i === qIdx ? 600 : 400 }}>
                <span>{i < qIdx ? '✓' : i === qIdx ? '→' : '○'}</span>
                {q.label.slice(0, 36)}{q.label.length > 36 ? '…' : ''}
              </div>
            ))}
          </div>
        </div>
      </div>

      <NavRow
        onBack={handleBack}
        onNext={handleNext}
        nextLabel={isLast ? 'See My Recommendations' : `Next (${qIdx + 1}/${questions.length})`}
        disabled={!hasAnswer}
      />
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   SCREEN 8 — RECOMMENDATION
═══════════════════════════════════════════════════════════════════ */
function RecommendationScreen({ data,profile, journeyKey, onBack, currentStep, totalSteps }) {
  const navigate = useNavigate();
  const R = data.screens.recommendation;
  const doc = R.doctor;
  const [apptOpen, setApptOpen] = useState(false);

  return (
    <div>
      <ScreenHeaderDFO />

      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Your Care Plan" />
      <h1 className={styles.pageTitle} style={{ marginBottom: 4 }}>{R.stepTitle}</h1>
      <p className={styles.pageSubtitle} style={{ marginBottom: 20 }}>
        Hi {profile?.fullName || 'there'} — based on your answers, here's your personalised care plan.
      </p>

      <div >
        <div>
          {/* Program card */}
          <div className={styles.recProgramCard}>
            <div className={styles.recBestMatchBadge}><Verified size={13} color="#16a34a" /> {R.program.badgeLabel}</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>{R.program.basedOnText}</div>
            <div className={styles.recProgramTitle}>{R.program.title}</div>
            <div className={styles.recProgramDesc}>{R.program.description}</div>
            <div className={styles.recTagRow}>
              {R.program.tags.map(t => <span key={t} className={styles.recTag}>{t}</span>)}
            </div>
          </div>

          {/* Doctor */}
          <div className={styles.doctorCard}>
            <div className={styles.doctorAvatar}>{doc.initials}</div>
            <div style={{ flex: 1 }}>
              <div className={styles.doctorName}>{doc.name}</div>
              <div className={styles.doctorRole}>{doc.role}</div>
              <div className={styles.doctorLoc}><MapPin size={13} color="#9ca3af" /> {doc.location}</div>
            </div>
            <div className={styles.doctorRating}><Star size={15} /><span className={styles.doctorRatingVal}>{doc.rating}</span></div>
          </div>

          {/* Action buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
            {R.actions.slice(0, 2).map(action => (
              <button
                key={action.value}
                className={action.primary ? `btn-primary ${styles.btnPrimary} ${styles.btnFull}` : `${styles.btnOutline} ${styles.btnFull}`}
                style={{ justifyContent: 'flex-start', gap: 12, padding: '12px 16px',  maxWidth:"stretch"                }}
                onClick={() => navigate(action.route)}
              >
                <span style={{ fontSize: 20 }}>{action.emoji}</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 700 }}>{action.label}</div>
                  <div style={{ fontSize: 12, opacity: 0.8 }}>{action.desc}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
        {/* <div className={styles.sideCol}>
          <SidePanel
            title="What happens next"
            items={[
              { icon: '📅', title: 'Book your appointment', desc: 'Schedule with a specialist at your convenience.' },
              { icon: '💊', title: 'Join a care program', desc: 'Structured support tailored to your journey.' },
              { icon: '📊', title: 'Track your progress', desc: 'Monitor your health journey on your dashboard.' },
            ]}
            extra={
              <div style={{ marginTop: 12 }}>
                <button
                  className={`btn-primary ${styles.btnPrimary} ${styles.btnFull}`}
                  onClick={() => navigate("/")}
                >
                  Go to Dashboard <ArrowRight size={14} color="white" />
                </button>
              </div>
            }
          />
        </div> */}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   APPOINTMENT MODAL (unchanged from original, simplified)
═══════════════════════════════════════════════════════════════════ */
function AppointmentModal({ AP, onClose }) {
  const stripDates = buildDateStrip();
  const [selIdx, setSelIdx] = useState(0);
  const [selSlot, setSelSlot] = useState('');
  const selDay = stripDates[selIdx];
  const available = getAvailableSlots(selDay);
  const fmtFull = d => `${['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()]}, ${d.getDate()} ${MONTH_NAMES[d.getMonth()]}`;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 16, maxWidth: 480, width: '100%', padding: 24, position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', cursor: 'pointer', fontSize: 20 }}>×</button>
        <div style={{ fontWeight: 700, fontSize: 18, color: 'var(--fc-purple)', marginBottom: 4 }}>{AP.doctor.name}</div>
        <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>{AP.doctor.role} · {AP.doctor.location}</div>

        {/* Date strip */}
        <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 8, marginBottom: 16 }}>
          {stripDates.map((d, i) => (
            <div key={i} onClick={() => { setSelIdx(i); setSelSlot(''); }}
              style={{ minWidth: 52, padding: '8px 6px', borderRadius: 10, textAlign: 'center', cursor: 'pointer', border: `1.5px solid ${i === selIdx ? 'var(--fc-purple)' : '#e5e7eb'}`, background: i === selIdx ? 'var(--fc-purple-soft)' : '#fff' }}>
              <div style={{ fontSize: 10, color: '#9ca3af' }}>{'Sun Mon Tue Wed Thu Fri Sat'.split(' ')[d.getDay()]}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: i === selIdx ? 'var(--fc-purple)' : '#1a1a1a' }}>{d.getDate()}</div>
            </div>
          ))}
        </div>

        <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--fc-purple)', marginBottom: 8 }}>Available Time Slots · {fmtFull(selDay)}</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 20 }}>
          {available.length === 0 && <span style={{ fontSize: 12, color: '#6b7280', gridColumn: '1/-1', textAlign: 'center' }}>No slots available.</span>}
          {available.map(slot => (
            <div key={slot} onClick={() => setSelSlot(slot)} style={{ padding: '8px 4px', borderRadius: 8, textAlign: 'center', cursor: 'pointer', border: `1.5px solid ${selSlot === slot ? 'var(--fc-purple)' : '#e5e7eb'}`, background: selSlot === slot ? 'var(--fc-purple-soft)' : '#fff' }}>
              <span style={{ fontSize: 11, fontWeight: 500, color: selSlot === slot ? 'var(--fc-purple)' : '#374151' }}>{slot}</span>
            </div>
          ))}
        </div>
        <button className={`btn-primary ${styles.btnPrimary} ${styles.btnFull}`} disabled={!selSlot} onClick={() => { if (selSlot) { onClose(); window.location.href = AP.successDashboardUrl; } }}>
          Confirm Appointment <ArrowRight size={15} color="white" />
        </button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════
   MAIN ORCHESTRATOR
═══════════════════════════════════════════════════════════════════ */
// const SCREEN_IDS = [
//   'welcome',
//   'consent',
//   'identify',
//   'lifeStage',
//   'entryReason',
//   'symptoms',
//   'safetyCheck',
//   'adaptive',      // 7
//   'recommendation',// 8
// ];
const SCREEN_IDS = [
  'welcome',
  'consent',
  'patient',
  'profile',
  'heightweight',
  'lifeStage',
  'entryReason',
  'symptoms',
  'safetyCheck',
  'adaptive',
  'recommendation',
];

export default function CareNavigator() {
  console.log("CareNavigator rendered");
  const navigate = useNavigate();
  const [screenIdx, setScreenIdx] = useState(0);
  const [isEmergency, setIsEmergency] = useState(false);

  // Patient profile (from identify screen)
  const [profile, setProfile] = useState({ fullName: '', mobile: '', ageGroup: '', maritalStatus: '', occupation: '', height: 160, weight: 60 });

  // const [identifyState,
  //   setIdentifyState] =
  //   useState({
  //     patientType: 'new',
  //     mobile: '',
  //     fullName: '',
  //     otp: '',
  //     otpSent: false,
  //     otpVerified: false,
  //     dob: '',
  //     ageGroup: '',
  //     marital: '',
  //     occupation: '',
  //     height: HEIGHT_DEFAULT_IN,
  //     weight: WEIGHT_DEFAULT_KG,
  //     profileSubStep: 0,
  //     showLogin: false,
  //     errors: {},
  //   });
  const [patientState, setPatientState] = useState({
    name: '',
    mobile: '',
    otp: ['', '', '', '', '', ''],
    otpSent: false,
    otpVerified: false,
    nameError: '',
    mobileError: '',
    isSendingOtp: false,
    isVerifyingOtp: false,
    ageGroup: '',
    marital: '',
    occupation: '',
    heightIn: HEIGHT_DEFAULT_IN,
    weightKg: WEIGHT_DEFAULT_KG,
  });
  const mergePatientState = (d) => setPatientState(prev => ({ ...prev, ...d }));

  // Life stage answers
  const [lifeStageAnswers, setLifeStageAnswers] = useState({});

  // Entry reason
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [activeRoute, setActiveRoute] = useState('pcos');

  // Symptoms
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [symptomDuration, setSymptomDuration] = useState('');
  const [symptomSeverity, setSymptomSeverity] = useState('');

  // Safety check
  const [safetyAnswers, setSafetyAnswers] = useState([]);

  // Adaptive intake
  const [adaptiveAnswers, setAdaptiveAnswers] = useState({});
  const totalSteps = SCREEN_IDS.length;
  const screen = isEmergency ? 'emergency' : SCREEN_IDS[screenIdx];
  const [welcomeData, setWelcomeData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/care-navigator/?clinic=mukta`)
        const data = await res.json();
        setWelcomeData(data)
      } catch (error) {
        console.log(error, "this is the error");
      }
    }
    fetchData();
  }, [])
  useEffect(() => {
    console.log(welcomeData, "Updated welcome data");
  }, [welcomeData]);

  const next = useCallback(() => setScreenIdx(i => Math.min(SCREEN_IDS.length - 1, i + 1)), []);
  const back = useCallback(() => setScreenIdx(i => Math.max(0, i - 1)), []);

  const journeyKey = useMemo(() => classifyJourney(profile, lifeStageAnswers), [profile, lifeStageAnswers]);


  return (
    <>
      <DigitalHealthFAB />

      <div className={styles.page}>
        <div className={styles.card}>
          {screen === 'welcome' && (
            <WelcomeScreen
              data={welcomeData}
              onStart={next}
            />
          )}

          {screen === 'consent' && (
            <ConsentScreen onNext={next} onBack={back} config={CONSENT_CONFIG} />
          )}

          {/* {screen === 'identify' && (
            <IdentifyPatientScreen
              onNext={next}
              onBack={back}
              setProfile={setProfile}
              identifyState={
                identifyState
              }

              setIdentifyState={
                setIdentifyState
              }
            />
          )} */}

          {screen === 'patient' && (
            <>
              <ScreenHeaderDFO />
              <NewPatientScreen
                stepIndex={screenIdx}
                totalSteps={totalSteps}
                patientState={patientState}
                onPatientStateChange={mergePatientState}
                onNext={next}
                onBack={back}
              />
            </>
          )}

          {screen === 'profile' && (
            <>
              <ScreenHeaderDFO />
              <ProfileScreen
                stepIndex={screenIdx}
                totalSteps={totalSteps}
                patientState={patientState}
                onPatientStateChange={mergePatientState}
                onNext={(d) => { mergePatientState(d); next(); }}
                onBack={back}
              />
            </>
          )}

          {screen === 'heightweight' && (
            <>
              <ScreenHeaderDFO />
              <HeightWeightScreen
                stepIndex={screenIdx}
                totalSteps={totalSteps}
                initialValues={{ heightIn: patientState.heightIn, weightKg: patientState.weightKg }}
                onNext={(d) => {
                  mergePatientState({ heightIn: d.heightIn, weightKg: d.weightKg });
                  setProfile(prev => ({
                    ...prev,
                    fullName: patientState.name,
                    mobile: patientState.mobile,
                    ageGroup: patientState.ageGroup,
                    maritalStatus: patientState.marital,
                    occupation: patientState.occupation,
                    height: d.heightIn,
                    weight: d.weightKg,
                  }));
                  next();
                }}
                onBack={back}
              />
            </>
          )}
          {screen === 'lifeStage' && (
            <LifeStageScreen
            data={welcomeData}

              profile={profile}
              lifeStageAnswers={lifeStageAnswers}
              setLifeStageAnswers={setLifeStageAnswers}
              onNext={next}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}

          {screen === 'entryReason' && (
            <EntryReasonScreen
              profile={profile}
              lifeStageAnswers={lifeStageAnswers}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              setActiveRoute={setActiveRoute}
              onNext={next}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}

          {screen === 'symptoms' && (
            <SymptomsScreen
            data={welcomeData}
              profile={profile}
              lifeStageAnswers={lifeStageAnswers}
              selectedOptions={selectedOptions}
              activeRoute={activeRoute}
              selectedSymptoms={selectedSymptoms}
              setSelectedSymptoms={setSelectedSymptoms}
              symptomDuration={symptomDuration}
              setSymptomDuration={setSymptomDuration}
              symptomSeverity={symptomSeverity}
              setSymptomSeverity={setSymptomSeverity}
              onNext={next}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}

          {screen === 'safetyCheck' && (
            <SafetyCheckScreen
            data={welcomeData}

              activeRoute={activeRoute}
              safetyAnswers={safetyAnswers}
              setSafetyAnswers={setSafetyAnswers}
              onNext={next}
              onEmergency={() => setIsEmergency(true)}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}

          {screen === 'emergency' && (
            <EmergencyScreen data={welcomeData.screens.emergencyRecommendation} onBack={() => setIsEmergency(false)} />
          )}

          {screen === 'adaptive' && (
            <AdaptiveIntakeScreen
            data={welcomeData}
              activeRoute={activeRoute}
              adaptiveAnswers={adaptiveAnswers}
              setAdaptiveAnswers={setAdaptiveAnswers}
              onNext={next}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}

          {screen === 'recommendation' && (
            <RecommendationScreen 
            data={welcomeData}
              profile={profile}
              journeyKey={journeyKey}
              onBack={back}
              currentStep={screenIdx}
              totalSteps={totalSteps}
            />
          )}
        </div>
      </div>
    </>
  );
}
